<template>
  <div :class="'wrapper' + (showMenu ? ' show-menu' : (showRightSideMenu ? ' show-side-menu' : ' no-menu')) + (showIcons ? ' show-icons' : ' no-icons') + (layouts && layouts.length > visibleItems ? ' has-overflow' : '') + (layouts && layouts.length > visibleItems && showOverflowMenu && !showMenu ? ' show-overflow' : '') + (editMode ? ' wrapper-editmode' : '') + (floating ? ' floating-ui' : ' fixed-ui') + (hasCampaigns ? ' has-campaigns-link' : '')">
    <link :href="localeCss" rel="stylesheet">
    <div class="editmode-infobar" v-if="editMode">
      <span class="infobar-text">{{ _('Layout editing mode enabled.') }}</span>
      <button type="button" class="infobar-button btn btn-xs btn-primary" v-on:click="toggleEditMode"><i class="fa fa-fw fa-check"></i> {{ _('Finished') }}</button>
    </div>
    <!-- Incidents in Johku, from the Johku team (Hub): over every view, until put away -->
    <div class="hub-incidents-overlay" v-if="hubAvailable">
      <LazyHubIncidentBanner theme="pos" dismissible />
    </div>
    <div class="menu-wrap" v-if="canShowMenu">
      <div class="menu-top">
        <div class="topmenu-item menu-hamburger" v-on:click="closeMenu" :title="_('Hide menu')" v-if="showMenu || showRightSideMenu"><i class="fa fa-fw fa-close"></i></div>
        <div class="topmenu-item menu-hamburger" v-on:click="openMenu" :title="_('Show menu')" v-else><i class="fa fa-fw fa-bars"></i><span v-if="hubUnread" class="hub-unread-dot" :title="_('Unread messages')"></span></div>
        <div class="topmenu-title">{{ shopTitle }}</div>
        <div class="topmenu-right" :style="!(showMenu || showRightSideMenu) ? 'pointer-events: none' : ''">
          <a :class="'menu-option logged-user clickable' + (showUserMenu ? '' : '')" v-on:click.stop="toggleRightNavi('user')"><span class="name">{{ userName }}</span><span class="user-profile-image" ref="profile" :data-initials="initials"><img v-if="false"/></span></a>
          <a :class="'menu-option settings clickable' + (showSettingsMenu ? '' : '')" v-on:click.stop="toggleRightNavi('settings')"><i class="fa fa-fw fa-cog"></i></a>
        </div>
      </div>
      <nav class="menu-side menu-layout" ref="side-menu">
        <div :class="'layout-strip' + (hasCampaigns ? ' with-campaigns-link' : '')">
          <draggable v-if="showEditLayoutButton" v-model="myLayouts" tag="ul" draggable=".layout" :delay="100" :delayOnTouchOnly="true" :componentData="{ attrs: { class: 'layout-selector' }}" v-on:change="layoutOrderChanged">
            <template v-for="layout in myLayouts" :key="layout.id">
              <li class="layout" v-if="layout.id !== 'add'"><a :class="'layout-option' + (activeLayout && activeLayout.id === layout.id ? ' active' : '')" v-on:click="setActiveLayout(layout.id)"><i :class="'fa fa-fw' + (layout.icon ? ' fa-' + layout.icon : '')"></i><span class="menu-layout-text">{{ layout.name }}</span><i class="fa fa-fw fa-pencil" v-if="showEditLayoutButton" v-on:click.stop="editLayout(layout)"></i></a></li>
              <li v-else-if="showAddLayoutButton" class="layout-add"><a class="layout-option" v-on:click="addLayout"><i class="fa fa-fw fa-plus"></i><span class="menu-layout-text">{{ _('New section') }}</span></a></li>
            </template>
          </draggable>
          <ul v-else class="layout-selector">
            <li :class="'layout' + (index < visibleItems ? ' on-screen' : ' off-screen')" v-for="(layout, index) in visibleLayouts"><a :class="'layout-option' + (activeLayout && activeLayout.id === layout.id ? ' active' : '')" v-on:click="setActiveLayout(layout.id)"><i :class="'fa fa-fw' + (layout.icon ? ' fa-' + layout.icon : '')"></i><span class="menu-layout-text">{{ layout.name }}</span><i class="fa fa-fw fa-pencil" v-if="showEditLayoutButton" v-on:click.stop="editLayout(layout)"></i></a></li>
            <li v-if="showAddLayoutButton" class="layout-add"><a class="layout-option" v-on:click="addLayout"><i class="fa fa-fw fa-plus"></i><span class="menu-layout-text">{{ _('New section') }}</span></a></li>
          </ul>
          <select class="form-control" v-model="selectedVersion" v-if="false">
            <option v-for="ver in versions" :value="ver">{{ getVersionName(ver) }}</option>
          </select>
          <a v-if="hasCampaigns" class="layout-option campaigns-link" :title="_('Campaigns')" v-on:click="openCampaigns"><i class="fa fa-fw fa-bullhorn"></i><span class="menu-layout-text">{{ _('Campaigns') }}</span></a>
        </div>
      </nav>
    </div>

    <div class="right-menu-wrap" v-if="canShowRightMenu">
      <nav class="menu-side menu-right" ref="right-side-menu">
        <div class="right-side-strip" v-if="showSettingsMenu || showUserMenu">
          <ul class="right-side-items">
            <li class="rightmenu-item" v-if="!showEditLayoutButton && isUiInfoButtonVisible">
              <span class="menu-option">
                <a href="javascript:;" v-on:click="uiInfoDialog"><i class="fa fa-fw fa-object-ungroup"></i> <span>{{ _('User interface') }}</span></a>
                <span style="display: flex;">
                  <a href="javascript:;" v-if="canSetEditMode && !showEditLayoutButton" v-on:click="toggleEditMode" class="topmenu-item layout-edit" :title="_('Edit layout')"><i :class="'fa fa-fw ' + (showEditLayoutButton ? 'fa-check' : 'fa-pencil')"></i></a>
                  <a href="javascript:;" v-if=!fullScreenMode v-on:click="enableFullscreen" class="topmenu-item menu-enable-fs" :title="_('Full screen')"><i class="fa fa-fw fa-arrows-alt"></i></a>
                  <a href="javascript:;" v-else v-on:click="exitFullscreen" class="topmenu-item menu-exit-fs" :title="_('Exit full screen')"><i class="fa fa-fw fa-compress"></i></a>
                </span>
              </span>
            </li>
            <li class="rightmenu-item" v-if="canAccessSettings" v-on:click.stop="showSettings()" style="cursor: pointer">
              <span class="menu-option">
                <a href="javascript:;" v-on:click="showSettings()"><i class="fa fa-fw fa-cog"></i> <span>{{ _('Settings') }}</span></a>
              </span>
            </li>
            <li class="rightmenu-item" v-if="hubAvailable" v-on:click.stop="showMessages()" style="cursor: pointer">
              <span class="menu-option">
                <a href="javascript:;" v-on:click="showMessages()"><i class="fa fa-fw fa-comments"></i> <span>{{ _('Messages') }}</span> <span v-if="hubUnread" class="badge hub-unread-count">{{ hubUnread }}</span></a>
              </span>
            </li>
            <li class="rightmenu-item" v-if="isBasicUser" v-on:click.stop="showFiles()" style="cursor: pointer">
              <span class="menu-option">
                <a href="javascript:;" v-on:click="showFiles()"><i class="fa fa-fw fa-images"></i> <span>{{ _('Files') }}</span></a>
              </span>
            </li>
            <li class="rightmenu-item" v-if="!canAccessSettings && isBasicUser && isFeatureEnabled('max')" v-on:click.stop="showMax()" style="cursor: pointer">
              <span class="menu-option">
                <a href="javascript:;" v-on:click="showMax()"><i class="fa fa-fw fa-wand-magic-sparkles"></i> <span>{{ _('Johku Max') }}</span></a>
              </span>
            </li>
            <li class="rightmenu-item" v-if="canAccessJohkuAccount" v-on:click.stop="showJohkuAccount()" style="cursor: pointer">
              <span class="menu-option">
                <a href="javascript:;" v-on:click="showJohkuAccount()"><i class="fa fa-fw fa-file-invoice"></i> <span>{{ _('Company profile') }}</span></a>
              </span>
            </li>
            <li class="rightmenu-item"><a class="menu-option logout clickable" @click="logout()"><span class="text">{{ _('Logout') }}</span><i class="fa fa-fw fa-unlock"></i></a></li>
            <li class="rightmenu-item" v-if="isBetterAuthSession"><a class="menu-option logout clickable" @click="logoutEverywhere()"><span class="text">{{ _('Log out everywhere') }}</span><i class="fa fa-fw fa-power-off"></i></a></li>
            <template v-if="isChannexEnabled">
              <li class="rightmenu-item"><a class="menu-option menu-subtitle messages" href="javascript:;">{{ _('Latest from External Sales Channels') }}</a></li>
              <li class="message-feed-wrap">
                <button v-on:click="enableMessaging()" class="btn btn-info" type="button" v-if="!isChannexMessagingEnabled && isFeatureEnabled('channexmessaging')"><i class="fa fa-fw fa-message-plus"></i> {{ _('Enable messaging') }}</button>
                <client-only>
                  <LazyChannexFeed :feed="channexFeedData" />
                </client-only>
              </li>
            </template>
          </ul>
        </div>
      </nav>
    </div>
    <div class="content-wrap">
      <div v-if="columns.length" :class="'container-fluid pos-container total-columns-' + columns.length + ' active-column-' + activeColumnIndex">
        <client-only>
          <div class="row pos-row" style="height: 100dvh">
            <template v-for="(col, index) in validColumns" :key="`column-wrapper-${index}-${col.identifier}`">
              <Suspense>
                <component
                  ref="columns"
                  :id="`column-${index}-${col.identifier}`"
                  :columnWidthClasses="columnWidthClasses[`column-${index}-${col.identifier}`]"
                  :defaultListFilterVisible="listFilterVisible[`column-${index}-${col.identifier}`]"
                  :column="col"
                  :columnIndex="index"
                  :columns="columns"
                  :className="'pos-column col-xs-12 ' + (columnWidth(col) > 0 ? 'col-md-' + columnWidth(col) : 'hidden-lg hidden-md') + ' column-index-' + index + ' column-identifier-' + col.identifier + (activeColumn == col.identifier ? ' column-active': '')"
                  :is="col.component.type"
                  :component="col.component"
                  :components="col.components"
                  :activeLayout="activeLayout"
                  :baseDomain="baseDomain"
                  :shopId="shopId"
                  :user="user"
                  :apiKey="apiKey"
                  :clientid="clientid"
                  :paymentterminal="paymentterminal"
                  :defaulttickettype="defaulttickettype"
                  v-on:observe="observeColumn"
                  v-on:unobserve="unobserveColumn"
                  v-on:setActiveComponent="(...args) => setActiveComponent(col, ...args)"
                  v-on:setActiveLayout="setActiveLayout"
                  v-on:toggleColumn="toggleActiveColumn">
                </component>
                <template #fallback>
                  <div style="display: flex; justify-content: center; align-items: center; height: 100%">
                    {{ _('Loading...') }} <i class="fa fa-fw fa-gear fa-spin"></i>
                  </div>
                </template>                  
              </Suspense>
            </template>
            <modal name="printQueueModal" :width="600" :height="130" :classes="printModalClasses" v-if="false">
              <div class="printqueue-container container" style="width: 100%" v-on:click="printFromManualPrintQueue">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="center">
                      <h3 class="text-center">{{ _('Print the next item from queue') }} ({{ manualPrintQueue.length }})</h3>
                      <div class="text-center"><button class="btn btn-default" v-on:click="printFromManualPrintQueue">{{ _('Print') }}</button></div>
                    </div>
                  </div>
                </div>
              </div>
            </modal>
          </div>
        </client-only>
      </div>
    </div>
    <div class="admin-receipt-wrap" v-if="pos">
      <div :class="'admin-receipt-toggle' + (numBasketItems ? ' has-items' : '')" v-if="isFloatingReceiptToggleVisible && !uiLocked" v-on:click="toggleFloatingReceipt">
        <i v-if="isFloatingReceiptVisible" class="fa fa-fw fa-arrow-circle-right"></i>
        <i v-else class="fa fa-fw fa-arrow-circle-left"></i>
        <span class="counter" v-if="numBasketItems && !isFloatingReceiptVisible">{{ numBasketItems }}</span>
      </div>
      <client-only>
        <div :class="floatingReceiptClass" v-if="isFloatingReceiptAvailable" style="height: 100dvh">
          <div class="admin-receipt-expand-toggle" v-if="isFloatingReceiptExpandToggleVisible && !uiLocked" v-on:click="toggleFloatingReceiptExpanded">
            <i v-if="isFloatingReceiptExpanded" class="fa fa-fw fa-arrow-circle-right"></i>
            <i v-else class="fa fa-fw fa-arrow-circle-left"></i>
          </div>
          <div class="flex-container">
            <LazyReceipt
                :component="floatingReceiptComponent"
                :className="'pos-column'"
                :baseDomain="baseDomain"
                :shopId="shopId"
                :user="user"
                :apiKey="apiKey"
                :clientid="clientid"
                :paymentterminal="paymentterminal"
                :defaulttickettype="defaulttickettype"
                :primary="true"
                :floatingcolumn="true"
                :is-floating-receipt-visible="isFloatingReceiptVisible"
                :is-admin-receipt-visible-in-layout="isAdminReceiptVisible"
            ></LazyReceipt>
          </div>
        </div>
      </client-only>
    </div>
    <client-only>
      <UploadTray />
    </client-only>
    <div class="menu-overflow-wrap" v-if="!showMenu && showIcons && layouts && visibleLayouts.length > visibleItems">
      <ul>
        <li class="overflow-trigger"><a class="layout-option" v-on:click="toggleOverflowMenu"><i :class="'fa fa-fw ' + (showOverflowMenu ? 'fa-chevron-left' : 'fa-chevron-right')"></i><span class="menu-layout-text">{{ _('More') }}</span></a></li>
        <li :class="'layout' + (index < visibleItems ? ' hidden' : ' overflow')" v-for="(layout, index) in visibleLayouts"><a :class="'layout-option' + (activeLayout && activeLayout.id === layout.id ? ' active' : '')" v-on:click="setActiveLayout(layout.id)"><i :class="'fa fa-fw' + (layout.icon ? ' fa-' + layout.icon : '')"></i><span class="menu-layout-text">{{ layout.name }}</span><i class="fa fa-fw fa-pencil" v-if="showEditLayoutButton" v-on:click.stop="editLayout(layout)"></i></a></li>
      </ul>
    </div>
    <div class="gaspump-listener-wrap" style="display: none" v-if="primarygaspump">
      <LazyGasPumpListener />
    </div>
    <div class="shop-locker" v-if="isShopLocked">
      <div>
        <h1>{{ _('This shop has been deactivated') }}</h1>
        <h4 style="text-align: center; line-height: 25px">{{ _('Despite the notices we have sent your commission invoice remains unpaid.') }}</h4>
        <div style="text-align: center; line-height: 25px">{{ _('This means your Johku shop has been automatically deactivated and your access has been denied.') }}<br />{{ _('You can reactivate the shop by paying the invoice within 10 days of deactivation.') }}<br /><br />
          {{ _('Your Johku shop will be automatically reactivated within 1-2 banking days after the referenced payment is recorded in our system. If you wish, you can request urgent reactivation by sending a request to tuki@johku.com along with the payment receipt. Urgent reactivation is a paid service, priced at 65 EUR per instance (VAT 0%).') }}<br /><br />
          {{ _('If the balance is not paid within 10 days, the invoice will be forwarded to debt collection.') }}</div>
        <div style="margin-top: 15px">
          <button class="btn btn-success" v-on:click="downloadInvoice"><i class="fa fa-fw fa-download"></i> {{ _('Download outstanding invoice') }}</button>
          <button class="btn btn-info" v-on:click="help"><i class="fa fa-fw fa-info"></i> {{ _('Instructions') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import channexhelpers from '~/lib/channexhelpers'
import constants from '~/lib/constants'
import errors from '~/lib/errors'
import gimmicks from '~/lib/gimmicks'
import layouts from '~/lib/layouts'
import modals from '~/lib/modals'
import numbasketitems from '~/lib/numbasketitems'
import permissions from '~/lib/permissions'
import { productNeedsModal } from '~/lib/products'
import debounce from 'lodash/debounce'
import { hideAllPoppers } from 'floating-vue'
import { DateTime } from 'luxon'
import { createShopAuthClient } from '~/lib/auth-client'
import { isBetterAuthApiKey } from '~/lib/johkuApiAuth'
import { applyPosReturnHash } from '~/lib/loginReturnHash'
import { isEditableScanTarget } from '~/lib/scanWedge'
import { maxWindowId } from '~/lib/maxspecs'
import { hubState } from '~/lib/hubState'

// Johku Hub's code and texts, loaded only for a shop with the hubmessaging feature flag
let hubCode = null
function loadHub () {
  hubCode ??= Promise.all([import('~/lib/hub'), import('#hub-messaging/lib/i18n')])
    .then(([hub, i18n]) => ({ ...hub, setLocale: i18n.setLocale }))
    .catch((error) => {
      // Try the import again next time
      hubCode = null
      throw error
    })
  return hubCode
}

function hubFailed (error) {
  console.error('Johku Hub:', error)
}

const ReservableProductListItem = defineAsyncComponent(() => import('~/components/ReservableProductListItem'))
const UserinterfaceInfo = defineAsyncComponent(() => import('~/components/modals/UserinterfaceInfo'))
const CampaignMobilepay = defineAsyncComponent(() => import('~/components/modals/CampaignMobilepay'))
const LatePayment = defineAsyncComponent(() => import('~/components/modals/LatePayment'))

export default defineNuxtComponent({
  setup () {
    const route = useRoute()
    useUserSession()

    if (import.meta.client && route.params.shopid) {
      const authClient = createShopAuthClient(String(route.params.shopid))
      const session = authClient.useSession()
      usePosAuthTokenSync(session)
    }
  },
  mixins: [channexhelpers, constants, errors, gimmicks, layouts, modals, numbasketitems, permissions],
  async asyncData (context) {
    const store = context.$store
    const route = useRoute()
    const config = useRuntimeConfig().public
    let state = store.state
    let shopId = route.params.shopid
    let ip = ''
    if (!store.state.clientid) {
      if (import.meta.server) {
        const event = useRequestEvent()
        if (event && shopId) {
          const { getUserSessionForShop } = await import('~/server/utils/session')
          const { ensureShopClientId } = await import('~/server/utils/clientid')
          const session = await getUserSessionForShop(event, shopId)
          const clientid = session?.clientid || await ensureShopClientId(event, shopId)
          store.commit('setClientId', clientid)
        }
      } else {
        await store.dispatch('clientid')
      }
    }
    const _ = (key) => {
      if (state && state._ && state._[state.locale] && state._[state.locale][key]) {
        return state._[state.locale][key]
      }
      return key
    }

    const isAdmin = () => {
      return store.state.userData && parseInt(store.state.userData.userlevel) >= 7
    }
    const isSuperAdmin = () => {
      return store.state.userData && parseInt(store.state.userData.userlevel) >= 10
    }
    const canAccessSettings = () => {
      return isAdmin()
    }
    if (store.state.clientid && config.baseDomain && shopId) {
      try {
        let userAgent = ''
        const headers = useRequestHeaders()
        if (headers) {
          userAgent = headers['user-agent']
          //ip = headers['x-real-ip'] || context.req.connection.remoteAddress
          ip = headers['x-real-ip']
        } else if (typeof navigator !== 'undefined') {
          userAgent = navigator.userAgent
        }
        let userName = store.state.userData ? store.state.userData.name : ''
        let userLang = store.state.userData ? store.state.userData.language : state.locale
        let response = await axios.get(config.baseDomain + shopId + '/clients/' + store.state.clientid + '.json?user=' + encodeURIComponent(userName) + '&ua=' + encodeURIComponent(userAgent) + (ip ? '&ip=' + encodeURIComponent(ip) : '') + '&version=' + userLang)
        if (response.data && response.data.id) {
          response.data.baseDomain = config.baseDomain
          response.data.localDomain = config.localDomain
          response.data.widgetDomain = config.widgetDomain
          response.data.clustered = config.clustered
          response.data.shopId = shopId
          response.data.floating = !!parseInt(response.data.floating)
          response.data.primarygaspump = !!parseInt(response.data.primarygaspump)
          // For now we assume we only have one pos, but in the future we might be able to switch between multiple
          if (response.data.sharedPos && response.data.sharedPos) {
            store.dispatch('setPos', response.data.sharedPos[0].id)
          }
          store.dispatch('setClientIdNumber', response.data.id)
          store.dispatch('setManifestPrinter', response.data.manifestprinter)
          if (response.data.defaultdelivery) {
            store.dispatch('setDefaultDeliverymethod', parseInt(response.data.defaultdelivery))
            store.dispatch('setPosDeliveryActive', true)
          } else {
            store.dispatch('setDefaultDeliverymethod', null)
            store.dispatch('setPosDeliveryActive', false)
          }
          store.dispatch('setClientName', response.data.name)
          store.dispatch('setFloating', response.data.floating)
          store.dispatch('setFloatingReceipt', response.data.floatingreceipt)
          store.dispatch('setSelfService', response.data.selfservice)
          store.dispatch('setColumnTabsMode', response.data.columntabs) // missing (older backend) = one row
          store.dispatch('setContract', response.data.contract)
          const layouts = []
          const settingsLayout = {
            id: 'settings',
            name: _('Settings'),
            data: JSON.stringify({
              columns: [{
                identifier: 'full',
                width: 12
              }],
              icon: 'cog',
              hidden: true
            }),
            ownComponent_layout: [{
              id: 3,
              column: 'full',
              component: {
                id: 'settingsmenu',
                link_id: 3,
                name: _('Settings'),
                type: 'SettingsMenu',
                data: null
              },
            },
            {
              id: 4,
              column: 'full',
              component: {
                id: 'companyprofile',
                link_id: 4,
                name: _('Company profile'),
                type: 'CompanyProfile',
                data: null
              },
            },
            {
              id: 5,
              column: 'full',
              component: {
                id: 'settings',
                link_id: 5,
                name: _('General settings'),
                type: 'Settings',
                data: null
              },
            },
            {
              id: 6,
              column: 'full',
              component: {
                id: 'communication',
                link_id: 6,
                name: _('Communication'),
                type: 'CommunicationSettings',
                data: null
              },
            },
            {
              id: 11,
              column: 'full',
              component: {
                id: 'delivery',
                link_id: 11,
                name: _('Delivery methods'),
                type: 'DeliverySettings',
                data: null
              },
            },
            {
              id: 7,
              column: 'full',
              component: {
                id: 'storefront',
                link_id: 7,
                name: _('Storefront'),
                type: 'StorefrontSettings',
                data: null
              },
            },
            {
              id: 14,
              column: 'full',
              component: {
                id: 'collection',
                link_id: 14,
                name: _('Storefront') + ': ' + _('Collections'),
                type: 'CollectionSettings',
                data: null
              },
            },
            {
              id: 8,
              column: 'full',
              component: {
                id: 'app',
                link_id: 8,
                name: _('Johku App'),
                type: 'PosSettings',
                data: null
              },
            },
            {
              id: 10,
              column: 'full',
              component: {
                id: 'accounting',
                link_id: 10,
                name: _('Financial Management'),
                type: 'AccountingSettings',
                data: null
              },
            },
            {
              id: 9,
              column: 'full',
              component: {
                id: 'saleschannel',
                link_id: 9,
                name: _('Sales Channels'),
                type: 'SalesChannelSettings',
                data: null
              },
            },
            {
              id: 12,
              column: 'full',
              component: {
                id: 'smartdevices',
                link_id: 12,
                name: _('Smart Devices'),
                type: 'SmartDeviceSettings',
                data: null
              },
            },
            {
              id: 17,
              column: 'full',
              component: {
                id: 'partnerintegrations',
                link_id: 17,
                name: _('Partner integrations'),
                type: 'PartnerIntegrationsSettings',
                data: null
              },
            }]
          }

          if (isSuperAdmin()) {
            settingsLayout.ownComponent_layout.push({
              id: 13,
              column: 'full',
              component: {
                id: 'admin',
                link_id: 12,
                name: _('Johku Admin'),
                type: 'Admin',
                data: null
              },
            })
            settingsLayout.ownComponent_layout.push({
              id: 15,
              column: 'full',
              component: {
                id: 'admincampaigns',
                link_id: 15,
                name: _('Campaigns'),
                type: 'AdminCampaigns',
                data: null
              },
            })
            settingsLayout.ownComponent_layout.push({
              id: 16,
              column: 'full',
              component: {
                id: 'adminuseraccess',
                link_id: 16,
                name: _('User access'),
                type: 'AdminUserAccess',
                data: null
              },
            })
            settingsLayout.ownComponent_layout.push({
              id: 18,
              column: 'full',
              component: {
                id: 'adminpartners',
                link_id: 18,
                name: _('Partners'),
                type: 'AdminPartners',
                data: null
              },
            })
            settingsLayout.ownComponent_layout.push({
              id: 19,
              column: 'full',
              component: {
                id: 'adminpartnerapi',
                link_id: 19,
                name: _('Partner API'),
                type: 'AdminPartnerApi',
                data: null
              },
            })
          }

          const storefrontLayout = {
            id: 'storefront',
            name: _('Storefront'),
            data: JSON.stringify({
              columns: [{
                identifier: 'full',
                width: 12
              }],
              icon: 'globe-pointer'
            }),
            ownComponent_layout: [{
              id: 1,
              column: 'full',
              component: {
                id: 'storefrontiframe',
                link_id: 1,
                name: _('Storefront'),
                type: 'StorefrontIFrame',
                data: null
              },
            }]
          }

          if (true || canAccessSettings()) {
            storefrontLayout.ownComponent_layout.push({
              id: 2,
              column: 'full',
              component: {
                id: 'storefrontsettings',
                link_id: 2,
                name: _('Settings'),
                type: 'StorefrontSettings',
                data: null
              }
            })
          }
          
          response.data.sharedLayout.push(storefrontLayout)

          if (canAccessSettings()) {
            if(response.data.sharedLayout.length > 1) {
              response.data.sharedLayout.splice(1,0, settingsLayout)
            } else {
              response.data.sharedLayout.push(settingsLayout)
            }
          }
          response.data.sharedLayout.forEach((layout) => {
            const def = JSON.parse(layout.data)
            const parsedColumns = []
            let isSettings = false
            if (def && def.columns) {
              def.columns.forEach((col, columnIndex) => {
                col.component = {}
                col.components = []
                layout.ownComponent_layout.forEach((comp, index) => {
                  if(comp && comp.component && comp.id) {
                    if(index === 0 && columnIndex === 0 && comp.component && comp.component.type === 'SettingsMenu') {
                      // Here we tag the layouts that have the settings menu as the first component of the first column.
                      // This is later used in the visibleLayouts -computed to hide such legacy monstrosities from menus
                      isSettings = true
                    }
                    comp.component.link_id = comp.id
                    if (comp.column == col.identifier) {
                      col.components.push(comp.component)
                    }
                  }
                })
                if (!col.components.length) {
                  col.components.push({
                    id: 0,
                    name: _('empty'),
                    type: 'EmptyColumn',
                    data: ''
                  })
                }
                col.component = col.components[0]
                parsedColumns.push(col)
              })
            }
            layouts.push({ id: layout.id, name: layout.name, icon: def && def.icon ? def.icon : null, hidden: def && !!def.hidden, isSettings: isSettings })
            layout.parsedColumns = parsedColumns
          })
          store.dispatch('setLayouts', layouts)
          response.data.myLayouts = [...layouts.filter(l => !l.hidden && !l.isSettings), { id: 'add' }]
          response.data.isDev = process.dev
          response.data.ip = ip
          return response.data
        }
      } catch (e) {
        // Suppress the 404 error if no client id was found
      }
    }
    return {
      id: 0,
      baseDomain: config.baseDomain,
      localDomain: config.localDomain,
      widgetDomain: config.widgetDomain,
      clustered: config.clustered,
      shopId: shopId,
      identifier: null,
      locked: false,
      floating: false,
      floatingreceipt: null,
      selfservice: false,
      paymentterminal: false,
      receiptprinter: false,
      ticketprinter: false,
      manifestprinter: false,
      reportprinter: false,
      defaulttickettype: 'combined',
      sharedPos: [],
      sharedLayout: [],
      sharedComponent: [],
      isDev: process.dev,
      hidemenuicons: true,
      myLayouts: [],
      ip: ip,
      // gimmicks: false,
      primarygaspump: false,
      contract: null,
    }
  },
  data () {
    return {
      dynamicColumns: null,
      bridge: null,
      inputInProgress: false,
      keyBuffer: [],
      scanBlocked: false,
      printJobs: [],
      printJobHistoryLength: 20,
      lastPrintJobTs: 0,
      manualPrintQueue: [],
      printModalClasses: ['v--modal', 'print-modal'],
      columnWidthClasses: {},
      listFilterVisible: {},
      socket: null,
      layoutReorderGuardUntil: 0,
      flushTimeout: false,
      currentVersion: false,
      updateInterval: false,
      updateDelay: 60, // seconds
      activeLayoutIndex: 0,
      showMenu: false,
      fullScreenMode: false,
      ticketReaderScanning: false,
      floatingReceiptVisible: false,
      floatingReceiptExpanded: false,
      lastHistoryState: null,
      activeColumn: '',
      activeColumnIndex: 0,
      previousActiveColumn: '',
      columnResizeObserver: null,
      menuSizeObserver: null,
      visibleItems: 0,
      showOverflowMenu: false,
      uiLocked: false,
      hasDisconnection: false,
      campaignItems: [],
      campaignShownKeys: [],
      campaignsLoadedAt: 0,
      campaignLoadStarted: false,
      campaignDialogVisible: false,
      channexFeedData: [],
      showUserMenu: false,
      showSettingsMenu: true,
      floating: false,
      primarygaspump: false,
      shopId: '',
      pendingRestore: null,
      restoreGeneration: 0,
      restoringFromHash: false,
      // canShowRightMenu: true
    }
  },
  computed: {
    ...mapGetters(['allSettings', 'locale', 'version', 'clientid', 'clientName', 'clientIdNumber', 'selfService', 'tabid', 'pos', 'user', 'userData', 'apiKey', 'linkedStores', 'layouts', 'editMode', 'unsavedChanges', 'joinChannel', 'lastSeenMessageTs']),
    isBetterAuthSession () {
      return isBetterAuthApiKey(this.apiKey)
    },
    // Johku Hub's messages (the Messages view, the order's Conversation tab) are behind the
    // shop's hubmessaging feature flag; without it the POS shows nothing of them
    hubEnabled () {
      return this.isFeatureEnabled('hubmessaging')
    },
    hubAvailable () {
      return this.hubEnabled && hubState.available
    },
    hubUnread () {
      return this.hubEnabled ? hubState.unread : 0
    },
    scheduler2Enabled () {
      return this.isFeatureEnabled('scheduler2.0')
    },
    shopTitle () {
      const settings = this.allSettings[this.shopId + '-' + this.locale]
      if (!settings) {
        return 'Johku'
      }
      return settings.marketingname || settings.companyname
    },
    localeCss () {
      return `/css/${this.version || 'fi_FI'}.css`
    },
    campaignsAllowed () {
      const settings = this.allSettings[this.shopId + '-' + this.locale]
      return !!(settings && this.userData) // Campaigns are shown regardless of settings.live (JDEV-3256; live is kept for a later use)
    },
    hasCampaigns () {
      return this.campaignsAllowed && this.campaignItems.length > 0
    },
    isShopLocked () {
      if (this.shopId && this.allSettings) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        if (settings && (Number(settings.disabled) === this.SHOP_LOCKED)) {
          return true
        }
      }
      return false
    },
    isShopLateOnPayments () {
      if (this.shopId && this.allSettings) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        if (settings && Number(settings.notify_ts) && Number(settings.notify_ts) < DateTime.now().toUnixInteger()) {
          return true
        }
      }
      return false
    },
    notifyTs () {
      if (this.shopId && this.allSettings) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        return settings ? Number(settings.notify_ts) : null
      }
      return null
    },
    deactivateTs () {
      if (this.shopId && this.allSettings) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        return settings ? Number(settings.deactivate_ts) : null
      }
      return null
    },
    isChannexMessagingEnabled () {
      if (this.shopId && this.allSettings) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        if (settings && settings.channex_group && parseInt(settings.channex_messaging)) {
          return true
        }
      }
      return false
    },
    isChannexEnabled () {
      if (this.shopId && this.allSettings) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        if (settings && settings.channex_group && parseInt(settings.channel_channex)) {
          return true
        }
      }
      return false
    },
    userName () {
      if (!this.userData) {
        return ''
      }
      return this.userData.name.trim()
    },
    canShowRightMenu () {
      if(parseInt(this.selfService)) {
        return false
      }
      return true
    },
    initials () {
      if (!this.userData) {
        return '-'
      }
      const name = this.userData.name.trim()
      let str = name.charAt(0)
      if(name.includes(' ')) {
        str = str + name.charAt(name.lastIndexOf(' ') + 1)
      }
      return str
    },
    showRightSideMenu: {
      // Save & Load this setting from some user-spesific backend mysteryplace
      get() {
        return this.$store.state.sideMenuOpen
      },
      set(newValue) {
        return this.$store.dispatch('setSideMenuOpen', newValue)
      }
    },
    title () {
      let title = 'Johku'
      if (this.shopId) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        if (settings && settings.companyname) {
          title = settings.companyname + ' \u2764 ' + title
        }
      }
      if (this.layouts && this.layouts[this.activeLayoutIndex] && this.layouts[this.activeLayoutIndex].name) {
        title = this.layouts[this.activeLayoutIndex].name + ' / ' + title
      }
      return title
    },
    columnIds () {
      if (!this.parsedColumns || !this.parsedColumns.length) {
        return []
      }
      return this.parsedColumns.map(p => p.identifier)
    },
    uiReady () {
      return !!(this.user && this.userData && this.id && this.pos && this.sharedLayout && this.sharedLayout.length)
    },
    allowedVersions () {
      const settings = this.allSettings && this.shopId && this.locale ? this.allSettings[this.shopId + '-' + this.locale] : null
      return settings && settings.versions ? settings.versions.split(';') : []
    },
    columnsUri () {
      if (!this.parsedColumns || !this.parsedColumns.length) {
        return ''
      }
      let parts = []
      this.parsedColumns.forEach(col => {
        parts.push(col.identifier + '-' + col.component.id)
      })
      if (this.dynamicColumns && this.dynamicColumns.length) {
        const detailsCol = this.dynamicColumns.find(c => c.identifier === 'details')
        if (detailsCol && detailsCol.component) {
          let paramArr = []
          for (const [key, value] of Object.entries(detailsCol.component.initData || {})) {
            if (typeof value !== 'undefined' && typeof value !== 'object' && value !== null) {
              paramArr.push(key + '=' + value)
            }
          }
          parts.push('details-' + detailsCol.component.type + '-' + paramArr.join(','))
        }
      }
      return parts.join('/')
    },
    isFloatingReceiptAvailable () {
      if (!this.floatingReceiptComponent || !this.apiKey || !this.clientIdNumber) {
        return false
      }
      return true
    },
    isStandardReceiptVisible () {
      if (!this.parsedColumns || !this.parsedColumns.length) {
        return false
      }
      return this.parsedColumns.filter((col) => col.component?.type === 'Receipt').length > 0
    },
    isFloatingReceiptExpandToggleVisible () {
      return this.isFloatingReceiptVisible
    },
    isFloatingReceiptToggleVisible () {
      return this.isFloatingReceiptAvailable
    },
    isFloatingReceiptVisible () {
      return this.isFloatingReceiptAvailable && this.floatingReceiptVisible
    },
    isFloatingReceiptExpanded () {
      return this.isFloatingReceiptAvailable && this.floatingReceiptExpanded
    },
    floatingReceiptComponent () {
      if (this.sharedComponent && this.sharedComponent.length) {
        const ar = this.sharedComponent.find(c => c.type === 'Receipt')
        if (ar) {
          return ar
        }
      }
      return null
    },
    floatingReceiptClass () {
      return 'row admin-receipt' + (this.isFloatingReceiptVisible ? '' : ' admin-receipt-hidden') + (this.isFloatingReceiptExpanded ? ' admin-receipt-expanded' : '')
    },
    canShowMenu () {
      if (!this.user || !this.userData || !this.parsedColumns || !this.id || parseInt(this.selfService)) {
        return false
      }
      return true
    },
    showIcons () {
      if (!this.user || !this.userData || !this.id) {
        return false
      }
      return !parseInt(this.hidemenuicons)
    },
    activeShops () {
      let basketIds = this.$store.state.basketIds
      let ret = {}
      ret[this.shopId] = true
      for (var shopIdWithIndex in basketIds) {
        if (Object.prototype.hasOwnProperty.call(basketIds, shopIdWithIndex)) {
          let siArr = shopIdWithIndex.split('-')
          let shopId = siArr[0]
          ret[shopId] = true
        }
      }
      return ret
    },
    paymentTerminalId () {
      if (this.paymentterminal && this.paymentterminal.match && this.paymentterminal.match(/auto/)) {
        return this.paymentterminal.split('-')[0]
      }
      return this.paymentterminal
    },
    literallyJustPrinted () {
      return (Math.round((new Date()).getTime() / 1000) - this.lastPrintJobTs) < 10
    },
    hasLegacyPrinters () {
      return this.receiptprinter || this.ticketprinter || this.manifestprinter || this.reportprinter
    },
    hasPaymentTerminal () {
      return parseInt(this.paymentterminal)
    },
    parsedColumns: {
      get () {
        if (this.sharedLayout && this.sharedLayout[this.activeLayoutIndex]) {
          return this.sharedLayout[this.activeLayoutIndex].parsedColumns
        }
        return []
      },
      set (newValue) {
        this.sharedLayout[this.activeLayoutIndex].parsedColumns = newValue
      }
    },
    validColumns () {
      return this.columns.filter(col => col.component && col.component.type)
    },
    columns () {
      const user = this.$store.state.user
      if (!user || !this.userData) {
        return this.loginColumns()
      }
      if (!this.id || !this.pos) {
        return this.clientIdColumns()
      }
      if (this.dynamicColumns && this.dynamicColumns.length) {
        return this.dynamicColumns
      }
      return this.parsedColumns
    },
    isCustomerDisplay () {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].component && this.columns[i].component.type == 'ClientReceipt') {
          return true
        }
      }
      return false
    },
    visibleLayouts () {
      return this.layouts && this.layouts.filter((layout) => !layout.hidden && !layout.isSettings)
    },
    activeLayout () {
      if (this.sharedLayout && this.sharedLayout.length && this.sharedLayout[this.activeLayoutIndex]) {
        return this.sharedLayout[this.activeLayoutIndex]
      }
      return null
    },
    activeLayoutId () {
      if (this.sharedLayout && this.sharedLayout.length && this.sharedLayout[this.activeLayoutIndex]) {
        return this.sharedLayout[this.activeLayoutIndex].id
      }
      return 0
    },
    isChangeUiButtonVisible () {
      if (!this.floating) { // Never allow switching fixed user interfaces
        return false
      }
      if (this.userData) {
        if (parseInt(this.userData.userlevel, 10) >= 7) {
          return true
        }
        if (this.userData.sharedClient && this.userData.sharedClient.length > 1) {
          return true
        }
      }
      return false
    },
    isUiInfoButtonVisible () {
      return true
    },
    isAdminReceiptVisible () {
      if (this.activeLayout && this.activeLayout.parsedColumns && this.activeLayout.parsedColumns.length) {
        for (let i = 0; i < this.activeLayout.parsedColumns.length; i++) {
          const component = this.activeLayout.parsedColumns[i].component
          if (component && component.type === 'Receipt') {
            const data = JSON.parse(component.data)
            if (data && parseInt(data.enableBilling)) {
              return true
            }
          }
        }
      }
      return false
    },
    isCodeCheckerVisible () {
      if (this.activeLayout && this.activeLayout.parsedColumns && this.activeLayout.parsedColumns.length) {
        for (let i = 0; i < this.activeLayout.parsedColumns.length; i++) {
          const component = this.activeLayout.parsedColumns[i].component
          if (component && component.type === 'CodeChecker') {
            return true
          }
        }
      }
      return false
    },
    isStockScannerVisible () {
      if (this.activeLayout && this.activeLayout.parsedColumns && this.activeLayout.parsedColumns.length) {
        for (let i = 0; i < this.activeLayout.parsedColumns.length; i++) {
          const component = this.activeLayout.parsedColumns[i].component
          if (component && component.type === 'StockScanner') {
            return true
          }
        }
      }
      return false
    },
    isTicketReaderVisible () {
      if (this.activeLayout && this.activeLayout.parsedColumns && this.activeLayout.parsedColumns.length) {
        for (let i = 0; i < this.activeLayout.parsedColumns.length; i++) {
          const component = this.activeLayout.parsedColumns[i].component
          if (component && component.type === 'TicketReader') {
            return true
          }
        }
      }
      return false
    }
  },
  methods: {
    ...mapActions([
      'setUnsavedChanges',
      'setLastSeenMessageTs',
      'setMobilepayPhoneNumber',
      'setMobilepayToken',
      'setVersion',
      'setCampaignCheckDone'
    ]),
    hashPath (layoutId, layoutOnly) {
      const layout = layoutId != null ? layoutId : this.activeLayoutId
      const parts = ['layout-' + layout]
      if (this.version) {
        parts.push('version-' + this.version)
      }
      if (!layoutOnly && this.columnsUri) {
        parts.push(this.columnsUri)
      }
      return '/' + this.shopId + '#/' + parts.join('/')
    },
    pushHash (layoutId, layoutOnly) {
      if (typeof window === 'undefined' || !window.history || !window.history.pushState) {
        return
      }
      const path = this.hashPath(layoutId, layoutOnly)
      if (this.lastHistoryState !== path) {
        window.history.pushState(null, null, path)
        this.lastHistoryState = path
      }
    },
    replaceHash (layoutId) {
      if (typeof window === 'undefined' || !window.history || !window.history.replaceState) {
        return
      }
      const path = this.hashPath(layoutId)
      if (this.lastHistoryState !== path) {
        window.history.replaceState(null, null, path)
        this.lastHistoryState = path
      }
    },
    applyVersionFromHash (version) {
      if (!version) {
        return
      }
      if (this.allowedVersions.length && !this.allowedVersions.includes(version)) {
        return
      }
      if (this.version !== version) {
        this.setVersion(version)
      }
    },
    async showSettings () {
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'SettingsMenu',
        title: this._('Settings')
      })
      this.closeRightNavi()
    },
    async showFiles () {
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'FileManager',
        title: this._('Files')
      })
      this.closeRightNavi()
    },
    async showMessages () {
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'HubMessages',
        title: this._('Messages')
      })
      this.closeRightNavi()
    },
    async showMax () {
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'MaxSpecList',
        title: this._('Reports, dashboards and tools')
      })
      this.closeRightNavi()
    },
    async showJohkuAccount () {
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'CompanyProfile',
        title: this._('Company profile'),
        initData: {
          activateTab: 'general'
        }
      })
      this.closeRightNavi()
    },
    downloadInvoice () {
      window.open(this.baseDomain + '/' + this.shopId + '/license?outstanding=true&apikey=' + this.apiKey)
    },
    help () {
      window.open('https://support.johku.com/Johku-Kauppiaalle/Johkun-palvelulaskutus/')
    },
    isFeatureEnabled(feature) {
      if (this.shopId && this.allSettings) {
        const settings = this.allSettings[this.shopId + '-' + this.locale]
        if(settings && settings.features) {
          const features = settings.features.split(';')
          return features.includes(feature)
        }
      }
      return false
    },
    syncSchedulerStyle () {
      if (typeof document === 'undefined' || !document.body) {
        return
      }
      document.body.classList.toggle('scheduler2', !!this.scheduler2Enabled)
    },
    showRightNavi(target = false) {
      this.showMenu = false
      this.showRightSideMenu = true
      switch(target) {
        case 'user':
          this.showUserMenu = true
          this.showSettingsMenu = false
          break
        default:
          this.showUserMenu = false
          this.showSettingsMenu = true
      }
      this.EventBus.$emit('rightNaviToggled')
    },
    toggleRightNavi(target = false) {
      this.showMenu = false
      this.showRightSideMenu = !this.showRightSideMenu
      if(this.showRightSideMenu) {
        switch(target) {
          case 'user':
            this.showUserMenu = true
            this.showSettingsMenu = false
            break
          default:
            this.showUserMenu = false
            this.showSettingsMenu = true
        }
      }
      this.EventBus.$emit('rightNaviToggled')
    },
    closeRightNavi() {
      this.showRightSideMenu = false
    },
    async loadCampaigns (autoOpen = true) {
      if (!this.uiReady || this.campaignLoadStarted) {
        return
      }
      if (!this.campaignsAllowed) {
        this.setCampaignCheckDone(true)
        return
      }
      this.campaignLoadStarted = true
      try {
        const { data } = await axios.get(
          this.baseDomain + this.shopId + '/campaigns/feed.json?apikey=' + this.apiKey + '&version=' + this.locale + '&include_dismissed=1',
          { timeout: 10000 } // a hung feed must not hold back the incoming offers popup
        )
        this.campaignsLoadedAt = Date.now()
        this.campaignItems = (data && Array.isArray(data.items) ? data.items : []).map(item => {
          if (item.image_url && !/^https?:\/\//.test(item.image_url) && !item.image_url.startsWith('blob:')) {
            return Object.assign({}, item, { image_url: this.baseDomain + item.image_url })
          }
          return item
        })
        const unseen = this.campaignItems.filter(item => !item.dismissed && !this.campaignShownKeys.includes(item.key))
        if (autoOpen && unseen.length && !this.campaignDialogVisible) {
          this.campaignDialog(false)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.campaignLoadStarted = false
        if (!this.campaignDialogVisible) {
          this.setCampaignCheckDone(true) // no campaign modal opened (or the feed failed): incoming offers may open now
        }
      }
    },
    refreshCampaignsOnFocus () {
      if (Date.now() - this.campaignsLoadedAt > 60000) {
        this.loadCampaigns(true)
      }
    },
    async openCampaigns () {
      await this.loadCampaigns(false)
      this.campaignDialog(true)
    },
    async loadChannexFeed() {
      if (!this.isChannexEnabled) {
        console.log('channex is not enabled')
        return
      }
      try {
        let response = await axios.get(this.baseDomain + this.shopId + '/channexmessages/all.json?apikey=' + this.apiKey)
        if (response && response.data) {
          this.channexFeedData = response.data
        } 
      } catch (error) {
        console.log(error)
      }
    },
    checkUnsavedChanges () {
      return new Promise((resolve, reject) => {
        if (!this.unsavedChanges) {
          resolve()
          return
        }
        this.showDialog({
          title: this._('You have unsaved changes. If you continue, they will be lost.'),
          buttons: [
            {
              title: this._('Cancel'),
              icon: 'check',
              handler: reject
            },
            {
              title: this._('Continue anyway'),
              class: 'danger',
              icon: 'trash',
              handler: () => {
                this.setUnsavedChanges(null)
                resolve()
              }
            }, 
          ],
          clickToClose: false
        })
      })
    },
    sameId (a, b) {
      return a != null && b != null && String(a) === String(b)
    },
    hashHasDetails (path) {
      const hash = path || (typeof window !== 'undefined' ? window.location.hash : '')
      return !!(hash && hash.includes('details-'))
    },
    maybeRestoreFromHash () {
      if (typeof window === 'undefined') {
        return
      }
      applyPosReturnHash(this.shopId)
      if (!this.uiReady || !window.location.hash) {
        return
      }
      if (this.hashHasDetails() && this.dynamicColumns && this.dynamicColumns.some(c => c.identifier === 'details')) {
        return
      }
      this.pathChanged(window.location.hash)
    },
    flushPendingRestore () {
      if (!this.pendingRestore) {
        return
      }
      this.EventBus.$emit('restoreDetails', this.pendingRestore)
    },
    async pathChanged (path) {
      this.restoringFromHash = true
      try {
        await this.applyPathChange(path)
      } finally {
        this.restoringFromHash = false
      }
    },
    async applyPathChange (path) {
      if (!path || !path.split) {
        if (this.sharedLayout && this.sharedLayout[0] && this.sharedLayout[0].id) {
          await this.setActiveLayout(this.sharedLayout[0].id, true)
        }
        return
      }
      const pathArr = path.split('/')
      for (const part of pathArr) {
        if (part.match(/^[a-z0-9]+-[a-z0-9]+/i)) {
          const parts = part.split('-')
          const cmd = parts[0]
          const id = parts[1]
          if (cmd === 'layout') {
            await this.setActiveLayout(id, true)
          } else if (cmd === 'version') {
            this.applyVersionFromHash(id)
          } else if (cmd === 'details') {
            const params = parts.slice(2).join('-')
            let data = {}
            if (params) {
              params.split(',').forEach(p => {
                const d = p.split('=')
                if (d[0]) {
                  data[d[0]] = d[1]
                }
              })
            }
            await nextTick()
            await this.restoreDetailsFromPath(id, data)
          } else if (this.columnIds.includes(cmd)) {
            const col = this.columns.find(c => c.identifier === cmd)
            if (col) {
              const component = col.components.find(c => this.sameId(c.id, id))
              if (component) {
                await this.setActiveComponent(col, component, true)
              }
            }
          }
        }
      }
    },
    async restoreDetailsFromPath (component, data) {
      const payload = {
        shopId: this.shopId,
        component,
        data
      }
      this.restoreGeneration += 1
      const generation = this.restoreGeneration
      this.pendingRestore = payload
      this.flushPendingRestore()
      const maxAttempts = 40
      const delayMs = 50
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        if (this.restoreGeneration !== generation || this.pendingRestore !== payload) {
          return
        }
        await new Promise(resolve => setTimeout(resolve, delayMs))
        if (this.restoreGeneration !== generation || this.pendingRestore !== payload) {
          return
        }
        this.flushPendingRestore()
      }
    },
    toggleOverflowMenu () {
      this.showOverflowMenu = !this.showOverflowMenu
    },
    campaignDialog (showAll = false) {
      if (this.campaignDialogVisible) {
        return
      }
      const items = showAll ? this.campaignItems : this.campaignItems.filter(item => !item.dismissed)
      if (!items.length) {
        return
      }
      items.forEach(item => {
        if (!item.dismissed && !this.campaignShownKeys.includes(item.key)) {
          this.campaignShownKeys.push(item.key)
        }
      })
      let $this = this
      this.campaignDialogVisible = true
      this.showModal('mobilepay', CampaignMobilepay, {
        props: {
          items,
          shopId: this.shopId,
          preview: false
        },
        handlers: {
          closed: function(e) {
            $this.campaignDialogVisible = false
            $this.setCampaignCheckDone(true)
          }
        }
      })
    },
    uiInfoDialog () {
      this.showModal('uiinfo', UserinterfaceInfo, {
        props: {
          baseDomain: this.baseDomain,
          localDomain: this.localDomain,
          clustered: this.clustered,
          shopId: this.shopId,
          apiKey: this.apiKey,
          clientid: this.clientid,
          clientName: this.clientName,
          clientIdNumber: this.clientIdNumber,
          pos: this.pos,
          userData: this.userData,
          isChangeUiButtonVisible: this.isChangeUiButtonVisible
        },
        events: {
          changeUi: this.changeUi
        },
        handlers: {
        },
        width: 800
      })
      //this.toggleMenu()
    },
    async changeUi () {
      try {
        this.closeMenu()
        this.closeRightNavi()
        await axios.post(this.baseDomain + this.shopId + '/clients/' + this.clientid + '/disconnect.json?apikey=' + this.apiKey, {})
        await this.$store.dispatch('resetBaskets')
      } catch (e) {
      }
    },
    async logout () {
      try {
        this.closeMenu()
        this.closeRightNavi()
        await this.$store.dispatch('logout')
      } catch (e) {
      }
    },
    logoutEverywhere () {
      this.closeMenu()
      this.closeRightNavi()
      this.showDialog({
        title: this._('Log out everywhere?'),
        text: this._('This logs you out on all your devices, in every shop and in My Johku. You will need to log in again on each device.'),
        width: 600,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Log out everywhere'),
            class: 'danger',
            icon: 'power-off',
            handler: async () => {
              const { error } = await createShopAuthClient(this.shopId).revokeSessions()
              if (error) {
                this.showError(this._('Logging out everywhere failed. Please try again.'))
                return
              }
              await this.logout()
            }
          }
        ]
      })
    },
    toggleFloatingReceipt () {
      this.floatingReceiptVisible = !this.floatingReceiptVisible
      hideAllPoppers()
    },
    toggleFloatingReceiptExpanded () {
      this.floatingReceiptExpanded = !this.floatingReceiptExpanded
    },
    enableFullscreen () {
      this.requestFullscreen(document.documentElement)
    },
    requestFullscreen (el) {
      if (el.requestFullscreen) {
        el.requestFullscreen().catch((err) => {
          alert(
            `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`,
          )
        })
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen().catch((err) => {
          alert(
            `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`,
          )
        })
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen().requestFullscreen().catch((err) => {
          alert(
            `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`,
          )
        })
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen().requestFullscreen().catch((err) => {
          alert(
            `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`,
          )
        })
      } else {
        // Fallback
        console.log('Fullscreen API is not supported.')
      }
    },
    isDocumentFullScreen () {
      return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)
    },
    syncFullScreenMode () {
      this.fullScreenMode = this.isDocumentFullScreen()
    },
    exitFullscreen () {
      if (!this.isDocumentFullScreen()) {
        this.syncFullScreenMode()
        return
      }
      const exit = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen
      if (exit) {
        Promise.resolve(exit.call(document)).catch(() => {})
      } else {
        // Fallback
        console.log('Fullscreen API is not supported.')
      }
    },
    columnWidth (col) {
      if (col.identifier === 'details') {
        return col.width
      }
      let minus = 0
      let totalColumnWidth = this.columns.filter(c => c.identifier !== 'details').map(c => c.width).reduce((a, e) => (a += e, a), 0)
      let availableWidth = 12 - totalColumnWidth
      for (let i = this.columns.length - 1; i >= 0; i--) {
        if (this.columns[i].identifier === 'details') {
          minus = this.columns[i].width - availableWidth // In case we have less than 12 column width, we can use up that extra space
        } else {
          if (col.identifier === this.columns[i].identifier) {
            return col.width - minus
          }
          minus = minus - Math.min(minus, this.columns[i].width)
        }
      }
      return col.width
    },
    async checkUpdates () {
      try {
        let response = await axios.get('/built.json?_=' + new Date().getTime())
        let rev = response.data
        if (!this.currentVersion) {
          this.currentVersion = rev
        } else {
          if (this.currentVersion != rev) {
            clearInterval(this.updateInterval)
            if (this.isCustomerDisplay) {
              this.EventBus.$emit('reloadWhenPossible')
            } else {
              this.$toast.error(
                '<h5>' + this._('Update available!') + '</h5>' + this._('Please reload the browser at your earliest convenience.') + '</p><a class="btn btn-default btn-xs" href="javascript:location.reload(true)">' + this._('Reload') + '</a>', 
                { 
                  autoClose: false, 
                  dangerouslyHTMLString: true
                }
              )
            }
          }
        }
      } catch(e) {
        // Fail silently
        // console.log(e)
      }
    },
    handleInput (event) {
      clearTimeout(this.flushTimeout)
      if (isEditableScanTarget(event)) {
        return
      }
      if (this.scanBlocked) { // The barcode not found dialog must be closed before the next scan
        this.keyBuffer = []
        return
      }
      if (event && event.key && event.key.match(/^[0-9a-z\:\/\-\_\.\=]$/i)) {
        this.keyBuffer.push(event.key)
        this.flushTimeout = setTimeout(() => { this.flushBuffer() }, 500)
      }
      if (event && event.keyCode == 13) {
        clearTimeout(this.flushTimeout)
        if (this.keyBuffer.length) {
          event.preventDefault()
          event.stopPropagation()
          this.flushBuffer()
        }
      }
    },
    flushBuffer () {
      let code = this.keyBuffer.join('')
      this.keyBuffer = []
      if (code) {
        this.processScan(code)
      }
    },
    async emitStockScanResult (code) {
      this.EventBus.$emit('stock.productScanned', {
        code: code
      })
    },
    async processMobilePayQrCode (code) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, {
          method: 'Exchange',
          code: code
        })
      } catch(e) {
        return this.showError(this._('Unable to process MobilePay QR code.'))
      }
      if (response && response.data) {
        this.showNotification(this._('MobilePay customer identified.'))
        this.setMobilepayPhoneNumber(response.data)
      }
    },
    async processScan (code) {
      let eventPrefix = ''
      if (this.isCodeCheckerVisible) {
        eventPrefix = 'check.'
      }
      // Fix character set issues from misconfigured scanners and the Finnish locale
      // Handle both normal and caps lock versions of special characters
      if (code.match(/^https[Öö]/)) {
        code = code.replace(/[Öö]/g, ':')  // Ö should be :
          .replace(/[\-_]/g, '/')          // - should be /
          .replace(/[Ää]/g, '-')           // Ä should be -
      }
      // If the first part is uppercase, assume caps lock is on
      if (code.match(/^HTTPS:/)) {
        code = code.replace(/\w{1}/g, function(val) {
          return val === val.toLowerCase() ? val.toUpperCase() : val.toLowerCase()
        })
      }
      var found = false
      if (code.match(/https:\/\/qr/) && code.match(/mobilepay/)) {
        this.processMobilePayQrCode(code)
      } else if (code.match(/^P[0-9]+S[0-9]+(C[0-9]+)?$/)) {
        if (this.isStockScannerVisible) {
          this.emitStockScanResult(code)
        } else {
          this.addProductToBasketWithBarcode(code)
        }
      } else {
        let shopId = false
        let identifier = false
        if (found = code.match(/https:\/\/[a-z0-9\-\.]+\/([^\/]+)\/qr\/([^\/]+)/)) {
          shopId = found[1]
          identifier = found[2]
        } else if (found = code.match(/.+\/.+/)) {
          let tArr = code.split('/')
          shopId = tArr[0]
          identifier = tArr[1]
          if (shopId !== shopId.toLowerCase()) { // Try to toggle case of shorter codes. We know that shopid must be lower case, but identifier might be mixed case
            shopId = shopId.toLowerCase()
            identifier = identifier.replace(/\w{1}/g, function(val) {
              return val === val.toLowerCase() ? val.toUpperCase() : val.toLowerCase()
            })
          }
        }
        let response = false
        let idStr
        if (shopId && identifier) {
          let type = identifier.substr(0, 1)
          switch (type) {
            case 'C': // Checkin / Checkout
              idStr = identifier.substring(1)
              response = await axios.get(this.baseDomain + shopId + '/reservations/' + idStr + '.json?items=true&apikey=' + this.apiKey)
              .catch((e) => {})
              if (response && response.data) {
                let id = response.data.id
                let orderId = null
                for (let i = 0; i < response.data.ownItem.length; i++) {
                  if (response.data.ownItem[i].order_id) {
                    orderId = response.data.ownItem[i].order_id
                    break
                  }
                }
                if (this.isCodeCheckerVisible) {
                  this.EventBus.$emit(eventPrefix + 'checkinScanned', {
                    shopId: shopId,
                    reservation: response.data,
                    order_id: orderId
                  })
                } else {
                  this.EventBus.$emit('showDetailsColumn', {
                    shopId: shopId,
                    component: 'ReservationDetails',
                    title: this._('Reservation') + ': ' + response.data.id,
                    data: {
                      id: id,
                      orderId: orderId
                    }
                  })
                }
              }
              break
            case 'R': // reservation
            case 'S': // seat
              if (this.isTicketReaderVisible && this.ticketReaderScanning) {
                this.EventBus.$emit('ticketReader.processScan', code)
                break
              }
              response = await axios.get(this.baseDomain + shopId + '/tickets/' + identifier + '.json')
              .catch((e) => {})
              if (response && response.data) {
                if (response.data.show_id) {
                  let showResponse = await axios.get(this.baseDomain + shopId + '/shows/' + response.data.show_id + '.json?details=true')
                  .catch((e) => {
                    let errorMessage = _('There was an unknown error.')
                    if (e && e.response && e.response.data && e.response.data.errorMessage) {
                      errorMessage = e.response.data.errorMessage
                    }
                    this.$toast.error(errorMessage)
                  })
                  if (showResponse && showResponse.data) {
                    this.EventBus.$emit(eventPrefix + 'ticketScanned', { ticket: response.data, show: showResponse.data, shopId: shopId })
                  }
                }
              }
              break
            case 'V': // value card
              idStr = identifier.substring(1)
              response = await axios.get(this.baseDomain + shopId + '/valuecards/' + idStr + (this.isCodeCheckerVisible && shopId === this.shopId ? '.json?details=true&apikey=' + this.apiKey : '/public.json'))
              .catch((e) => {
                let errorMessage = this._('There was an unknown error.')
                if (e && e.response && e.response.data && e.response.data.errorMessage) {
                  errorMessage = e.response.data.errorMessage
                }
                this.$toast.error(errorMessage)
              })
              if (response && response.data) {
                this.EventBus.$emit(eventPrefix + 'valuecardScanned', response.data)
              }
              break
            case 'P': // product
              let id = identifier.substring(1)
              let count = 1
              if (id.indexOf('C') > 0) {
                let idArr = id.split(/C/)
                id = idArr[0]
                count = parseInt(idArr[1], 10)
              }
              if (!count) {
                count = 1
              }
              if (this.activeShops[shopId]) {
                if (this.isCodeCheckerVisible) {
                  this.EventBus.$emit(eventPrefix + 'productScanned', {
                    shopId: shopId,
                    id: id,
                    count: count
                  })
                } else {
                  this.addProductToBasket(shopId, id, count)
                }
              }
              break
            case 'U': // cUstomer
              idStr = identifier.substring(1)
              response = await axios.get(this.baseDomain + shopId + '/customers/' + idStr + '.json?apikey=' + this.apiKey)
              .catch((e) => {})
              if (response && response.data) {
                this.EventBus.$emit(eventPrefix + 'setCustomer', {
                  data: response.data,
                  pos: this.pos,
                  index: '1',
                  clientid: null
                })
              }
              break
          }
        } else {
          await this.processBarcode(code, eventPrefix)
        }
      }
      this.keyBuffer = []
    },
    // Any other code is a product barcode (EAN, UPC, GTIN-14 or a producer's own code) or a loyalty card
    async processBarcode (code, eventPrefix) {
      if (code.length < 6) { // Stray key presses outside input fields
        return
      }
      if (this.isStockScannerVisible) {
        this.emitStockScanResult(code)
        return
      }
      if (await this.addProductToBasketWithEan(code)) {
        return
      }
      if (code.length >= 10 && await this.setCustomerWithCard(code, eventPrefix)) {
        return
      }
      if (!(this.isTicketReaderVisible && this.ticketReaderScanning)) { // The ticket reader reports its own unknown codes
        this.showBarcodeNotFound(code)
      }
    },
    async setCustomerWithCard (code, eventPrefix) {
      const response = await axios.get(this.baseDomain + this.shopId + '/customers/' + btoa(code) + '.json?apikey=' + this.apiKey)
      .catch((e) => {})
      if (!response || !response.data) {
        return false
      }
      this.EventBus.$emit(eventPrefix + 'setCustomer', {
        data: response.data,
        pos: this.pos,
        index: '1',
        clientid: null
      })
      return true
    },
    showBarcodeNotFound (code) {
      this.scanBlocked = true
      this.showDialog({
        title: this._('Product not found'),
        text: this._('No product has the barcode %s. Add the barcode to the product or create the product, and scan it again.').replace('%s', code),
        variant: 'danger',
        clickToClose: false,
        buttons: [
          {
            title: this._('Close'),
            class: 'danger',
            icon: 'close',
            handler: () => {}
          }
        ],
        onClosed: () => {
          this.scanBlocked = false
        }
      })
    },
    async addProductToBasketWithBarcode (code) {
      let $this = this
      let response = false
      let shopId = false
      let productId = false
      let count = 1
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/products.json?code=' + code)
        shopId = response.data.shopId
        productId = response.data.productId
        count = response.data.count
      } catch(err) {
        this.showAddedToBasketError(err)
        return
      }
      try {
        response = await axios.get(this.baseDomain + shopId + '/products/' + productId + '.json')
      } catch(e) {}
      if (response && response.data && response.data.id) {
        let product = response.data
        if (this.showReservationModal(product, shopId)) {
          return
        }
        let data = {
          locale: this.$store.state.locale,
          product: product,
          shopId: shopId,
          count: count
        }
        this.$store.dispatch('addToBasket', data)
        .then(function () {
          $this.showAddedToBasketNotification()
        })
        .catch(function (err) {
          $this.showAddedToBasketError(err)
        })
      }
    },
    // Returns false only when no product has the barcode
    async addProductToBasketWithEan (ean) {
      let $this = this
      let response = false
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/products.json?ean=' + encodeURIComponent(ean))
      } catch(e) {
        if (e && e.response && e.response.status === 404) {
          return false
        }
        this.showAddedToBasketError(e && e.response && e.response.data)
        return true
      }
      if (!response || !response.data || !response.data.id) {
        return false
      }
      let product = response.data
      if (this.showReservationModal(product, this.shopId)) {
        return true
      }
      let data = {
        locale: this.$store.state.locale,
        product: product,
        shopId: this.shopId,
        count: 1
      }
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification()
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
      })
      return true
    },
    async addProductToBasket (shopId, id, count) {
      let $this = this
      let response = false
      try {
        response = await axios.get(this.baseDomain + shopId + '/products/' + id + '.json')
      } catch(e) {}
      if (response && response.data && response.data.id) {
        let product = response.data
        if (this.showReservationModal(product, shopId)) {
          return
        }
        let data = {
          locale: this.$store.state.locale,
          product: product,
          shopId: shopId,
          count: count
        }
        this.$store.dispatch('addToBasket', data)
        .then(function () {
          $this.showAddedToBasketNotification()
        })
        .catch(function (err) {
          $this.showAddedToBasketError(err)
        })
      }
    },
    showReservationModal (product, shopId) {
      if (parseInt(product.subtype, 10) === 8) { // Content => no need to do anything
        return true
      }
      if (productNeedsModal(product)) {
        this.showModal('reservableproductlistitem', ReservableProductListItem, {
          props: {
            product: product,
            productShopId: shopId,
            column: this.columns[0] || null,
            activeComponent: this.columns[0] && this.columns[0].components ? this.columns[0].components[0] : null,
            baseDomain: this.baseDomain,
            auto: true
          },
          events: {
          },
          handlers: {
          },
          width: 800
        })
        return true
      }
      return false
    },
    showAddedToBasketNotification () {
    },
    showAddedToBasketError (err) {
      this.$toast.error(err && err.errorMessage ? err.errorMessage : this._('Adding the product to basket failed:') + ' ' + this._('There was an unknown error.'))
    },
    async reloadSettings (shopId) {
      let response = false
      if (this.baseDomain && shopId) {
        try {
          if (shopId === this.shopId) {
            response = await axios.get(this.baseDomain + shopId + '/' + this.$store.state.locale + '/settings.json?apikey=' + this.$store.getters.apiKey + '&version=' + this.$store.state.version + '&pricetiers=true&files=true&alltags=true&deliverymethods=true')
          } else {
            response = await axios.get(this.baseDomain + shopId + '/' + this.$store.state.locale + '/settings/public.json?client=' + this.$store.state.clientid + '&shop=' + this.shopId + '&version=' + this.$store.state.version + '&pricetiers=true&deliverymethods=true')
          }
        } catch (e) {
          return
        }
        this.$store.dispatch('setSettings', {
          shopId: shopId,
          locale: this.$store.state.locale,
          settings: response.data
        })
      }
    },
    async reloadClient () {
      const activeComponentIds = {}
      this.parsedColumns.forEach(col => {
        if (col && col.identifier && col.component) {
          activeComponentIds[col.identifier] = col.component.id
        }
      })
      let response = false
      if (this.baseDomain && this.shopId) {
        let userAgent = ''
        if (typeof navigator !== 'undefined') {
          userAgent = navigator.userAgent
        }
        let userName = this.$store.state.userData ? this.$store.state.userData.name : ''
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/clients/' + this.$store.state.clientid + '.json?user=' + encodeURIComponent(userName) + '&ua=' + encodeURIComponent(userAgent) + (this.ip ? '&ip=' + encodeURIComponent(this.ip) : '') + '&version=' + this.$store.state.locale)
        } catch (e) {
          // do nothing, used to catch a 404 when a client id is disconnected
        }
      }
      if (response.data && response.data.id) {
        this.activeLayoutIndex = 0
        this.id = response.data.id
        this.locked = response.data.locked
        this.sharedPos = response.data.sharedPos
        this.receiptprinter = response.data.receiptprinter
        this.ticketprinter = response.data.ticketprinter
        this.manifestprinter = response.data.manifestprinter
        this.reportprinter = response.data.reportprinter
        this.paymentterminal = response.data.paymentterminal
        this.defaulttickettype = response.data.defaulttickettype
        this.hidemenuicons = response.data.hidemenuicons
        // For now we assume we only have one pos, but in the future we might be able to switch between multiple
        if (response.data.sharedPos && response.data.sharedPos) {
          this.$store.dispatch('setPos', response.data.sharedPos[0].id)
        }
        this.floating = !!parseInt(response.data.floating)
        // this.gimmicks = response.data.gimmicks
        this.primarygaspump = !!parseInt(response.data.primarygaspump)
        this.contract = response.data.contract
        this.$store.dispatch('setClientIdNumber', response.data.id)
        this.$store.dispatch('setManifestPrinter', response.data.manifestprinter)
        if (response.data.defaultdelivery) {
          this.$store.dispatch('setDefaultDeliverymethod', parseInt(response.data.defaultdelivery))
          // Note: we're not setting posDeliveryActive on purpose, because this just reloads the user interface
        } else {
          this.$store.dispatch('setDefaultDeliverymethod', null)
          this.$store.dispatch('setPosDeliveryActive', false) // However, if we don't have a default delivery method, we must set this to false
        }
        this.$store.dispatch('setClientName', response.data.name)
        this.$store.dispatch('setFloating', response.data.floating)
        this.$store.dispatch('setFloatingReceipt', response.data.floatingreceipt)
        this.$store.dispatch('setSelfService', response.data.selfservice)
        this.$store.dispatch('setColumnTabsMode', response.data.columntabs) // missing (older backend) = one row
        this.$store.dispatch('setContract', response.data.contract)
        const layouts = []
        const settingsLayout = {
          id: 'settings',
          name: this._('Settings'),
          data: JSON.stringify({
            columns: [{
              identifier: 'full',
              width: 12
            }],
            icon: 'cog',
            hidden: true
          }),
          ownComponent_layout: [{
            id: 3,
            column: 'full',
            component: {
              id: 'settingsmenu',
              link_id: 3,
              name: this._('Settings'),
              type: 'SettingsMenu',
              data: null
            },
          },
          {
            id: 4,
            column: 'full',
            component: {
              id: 'companyprofile',
              link_id: 4,
              name: this._('Company profile'),
              type: 'CompanyProfile',
              data: null
            },
          },
          {
            id: 5,
            column: 'full',
            component: {
              id: 'settings',
              link_id: 5,
              name: this._('General settings'),
              type: 'Settings',
              data: null
            },
          },
          {
            id: 6,
            column: 'full',
            component: {
              id: 'communication',
              link_id: 6,
              name: this._('Communication'),
              type: 'CommunicationSettings',
              data: null
            },
          },
          {
            id: 11,
            column: 'full',
            component: {
              id: 'delivery',
              link_id: 11,
              name: this._('Delivery methods'),
              type: 'DeliverySettings',
              data: null
            },
          },
          {
            id: 7,
            column: 'full',
            component: {
              id: 'storefront',
              link_id: 7,
              name: this._('Storefront'),
              type: 'StorefrontSettings',
              data: null
            },
          },
          {
            id: 14,
            column: 'full',
            component: {
              id: 'collection',
              link_id: 7,
              name: this._('Storefront') + ': ' + this._('Collections'),
              type: 'CollectionSettings',
              data: null
            },
          },
          {
            id: 8,
            column: 'full',
            component: {
              id: 'app',
              link_id: 8,
              name: this._('Johku App'),
              type: 'PosSettings',
              data: null
            },
          },
          {
            id: 10,
            column: 'full',
            component: {
              id: 'accounting',
              link_id: 10,
              name: this._('Financial Management'),
              type: 'AccountingSettings',
              data: null
            },
          },
          {
            id: 9,
            column: 'full',
            component: {
              id: 'saleschannel',
              link_id: 9,
              name: this._('Sales Channels'),
              type: 'SalesChannelSettings',
              data: null
            },
          },
          {
            id: 12,
            column: 'full',
            component: {
              id: 'smartdevices',
              link_id: 12,
              name: this._('Smart Devices'),
              type: 'SmartDeviceSettings',
              data: null
            },
          },
          {
            id: 17,
            column: 'full',
            component: {
              id: 'partnerintegrations',
              link_id: 17,
              name: this._('Partner integrations'),
              type: 'PartnerIntegrationsSettings',
              data: null
            },
          }]
        }
        if (this.isSuperAdmin) {
          settingsLayout.ownComponent_layout.push({
            id: 13,
            column: 'full',
            component: {
              id: 'admin',
              link_id: 12,
              name: this._('Johku Admin'),
              type: 'Admin',
              data: null
            },
          })
          settingsLayout.ownComponent_layout.push({
            id: 15,
            column: 'full',
            component: {
              id: 'admincampaigns',
              link_id: 15,
              name: this._('Campaigns'),
              type: 'AdminCampaigns',
              data: null
            },
          })
          settingsLayout.ownComponent_layout.push({
            id: 16,
            column: 'full',
            component: {
              id: 'adminuseraccess',
              link_id: 16,
              name: this._('User access'),
              type: 'AdminUserAccess',
              data: null
            },
          })
          settingsLayout.ownComponent_layout.push({
            id: 18,
            column: 'full',
            component: {
              id: 'adminpartners',
              link_id: 18,
              name: this._('Partners'),
              type: 'AdminPartners',
              data: null
            },
          })
          settingsLayout.ownComponent_layout.push({
            id: 19,
            column: 'full',
            component: {
              id: 'adminpartnerapi',
              link_id: 19,
              name: this._('Partner API'),
              type: 'AdminPartnerApi',
              data: null
            },
          })
        }

        const storefrontLayout = {
          id: 'storefront',
          name: this._('Storefront'),
          data: JSON.stringify({
            columns: [{
              identifier: 'full',
              width: 12
            }],
            icon: 'globe-pointer'
          }),
          ownComponent_layout: [{
            id: 1,
            column: 'full',
            component: {
              id: 'storefrontiframe',
              link_id: 1,
              name: this._('Storefront'),
              type: 'StorefrontIFrame',
              data: null
            },
          }]
        }
        
        if (true || this.canAccessSettings) {
            storefrontLayout.ownComponent_layout.push({
              id: 2,
              column: 'full',
              component: {
                id: 'storefrontsettings',
                link_id: 2,
                name: this._('Settings'),
                type: 'StorefrontSettings',
                data: null
              }
            })
          }

        response.data.sharedLayout.push(storefrontLayout)

        if (this.canAccessSettings) {
          if(response.data.sharedLayout.length > 1) {
            response.data.sharedLayout.splice(1,0, settingsLayout)
          } else {
            response.data.sharedLayout.push(settingsLayout)
          }
        }
        response.data.sharedLayout.forEach((layout) => {
          const def = JSON.parse(layout.data)
          const parsedColumns = []
          let isSettings = false
          if (def && def.columns) {
            def.columns.forEach((col, columnIndex) => {
              col.component = {}
              col.components = []
              layout.ownComponent_layout.forEach((comp, index) => {
                if(comp && comp.component && comp.id) {
                  // Here we tag the layouts that have the settings menu as the first component of the first column.
                  // This is later used in the visibleLayouts -computed to hide such legacy monstrosities from menus
                  if(index === 0 && columnIndex === 0 && comp.component && comp.component.type === 'SettingsMenu') {
                    isSettings = true
                  }
                  comp.component.link_id = comp.id
                  if (comp.column == col.identifier) {
                    col.components.push(comp.component)
                  }
                }
              })
              if (!col.components.length) {
                col.components.push({
                  id: 0,
                  name: this._('empty'),
                  type: 'EmptyColumn',
                  data: ''
                })
              }
              let component
              if (activeComponentIds[col.identifier]) {
                component = col.components.find(c => c.id === activeComponentIds[col.identifier])
              }
              if (!component) {
                component = col.components[0]
              }
              col.component = component
              parsedColumns.push(col)
            })
          }
          layouts.push({ id: layout.id, name: layout.name, icon: def && def.icon ? def.icon : null, hidden: def && !!def.hidden, isSettings: isSettings })
          layout.parsedColumns = parsedColumns
        })
        this.sharedLayout = response.data.sharedLayout
        this.sharedComponent = response.data.sharedComponent
        this.$store.dispatch('setLayouts', layouts)
        this.myLayouts = [...layouts.filter(l => !l.hidden && !l.isSettings), { id: 'add' }]
        // Campaigns load from the uiReady watcher, not from layout reloads.
      } else {
        this.id = 0
        this.locked = false
        this.sharedComponent = []
        this.sharedPos = []
        this.sharedLayout = []
        this.receiptprinter = false
        this.ticketprinter = false
        this.manifestprinter = false
        this.reportprinter = false
        this.paymentterminal = false
        this.defaulttickettype = 'combined'
        this.hidemenuicons = false
        this.$store.dispatch('setColumnTabsMode', null)
        // this.gimmicks = false
        this.primarygaspump = false
        this.contract = null
      }
      this.dynamicColumns = null
      await nextTick()
      try {
        if(this.$refs['side-menu']) {
          this.menuSizeObserver.unobserve(this.$refs['side-menu'])
        }
      } catch(e) {
      }
      if(this.$refs['side-menu']) {
        this.menuSizeObserver.observe(this.$refs['side-menu'])
      }
      applyPosReturnHash(this.shopId)
      if (window.location.hash) {
        this.pathChanged(window.location.hash)
      }
      this.updateOverflowNavi()
    },
    hasComponent (id) {
      if (!this.sharedLayout) {
        return false
      }
      let layouts = this.sharedLayout
      for (var h = 0; h < layouts.length; h++) {
        let cols = layouts[h].parsedColumns
        for (var i = 0; i < cols.length; i++) {
          for (var j = 0; j < cols[i].components.length; j++) {
            let component = cols[i].components[j]
            if (component && this.sameId(component.id, id)) {
              return true
            }
          }
        }
      }
      return false
    },
    hasLayout (id) {
      if (!this.sharedLayout) {
        return false
      }
      for (var i = 0; i < this.sharedLayout.length; i++) {
        if (this.sharedLayout[i].id == id) {
          return true
        }
      }
      return false
    },
    setActiveComponent (column, component, skipState) {
      return new Promise(async (resolve) => {
        // This check is maybe not the best, but seems to work for normal layouts
        // If we're switching the details column component, we should check
        // And also if there's just one column visible (in settings mostly)
        // But this won't work if there is a second column in the settings view...
        if (column.identifier === 'details' || (this.parsedColumns && this.parsedColumns.length === 1)) {
          try {
            await this.checkUnsavedChanges()
          } catch(e) {
            resolve()
            return
          }
        }
        let foundColumn = null
        if (column.identifier === 'details') {
          for (var i = 0; i < this.dynamicColumns.length; i++) {
            if (this.dynamicColumns[i].identifier === column.identifier) {
              this.dynamicColumns[i].component = component
              foundColumn = this.dynamicColumns[i]
              break
            }
          }
          if (component.id === 0) {
            this.dynamicColumns[i].component = component
          }
        } else if (this.parsedColumns) {
          for (var i = 0; i < this.parsedColumns.length; i++) {
            if (this.parsedColumns[i].identifier === column.identifier) {
              this.parsedColumns[i].component = component
              foundColumn = this.parsedColumns[i]
              break
            }
          }
          if (component.id === 0 && this.parsedColumns[i]) {
            this.parsedColumns[i].component = component
          }
        }
        await nextTick()
        if (!skipState) {
          this.pushHash()
        }
        if (foundColumn) {
          await this.setActiveColumn(foundColumn)
        }
        resolve()
      })
    },
    setActiveLayout (id, skipState) {
      return new Promise(async (resolve) => {
        try {
          await this.checkUnsavedChanges()
        } catch(e) {
          resolve()
          return
        }
        if (this.sharedLayout) {
          for (var i = 0; i < this.sharedLayout.length; i++) {
            if (this.sameId(this.sharedLayout[i].id, id)) {
              if (this.activeLayoutIndex === i) {
                // A second click on the already-active layout resets the left column.
                // Hash restore passes skipState and must not do that, or the list
                // remounts and misses restoreDetails.
                if (!skipState && this.columns[0] && this.columns[0].components && this.columns[0].components[0]) {
                  this.setActiveComponent(this.columns[0], this.columns[0].components[0])
                  this.EventBus.$emit('restoreLeftColumn')
                }
              } else {
                this.activeLayoutIndex = i
                this.dynamicColumns = null
                if (!this.editMode) {
                  this.showMenu = false
                }
              }
              await nextTick()
              if (!skipState) {
                this.pushHash(id)
              }
              resolve()
              return
            }
          }
          this.updateOverflowNavi()
        }
        resolve()
      })
    },
    setActiveColumn (column) {
      return new Promise(async (resolve) => {
        // Mostly for mobile / single column view
        if (typeof column === 'string') {
          column = { identifier: column }
        }
        let cols = this.columns
        for (var i = 0; i < cols.length; i++) {
          if (cols[i].identifier === column.identifier) {
            this.activeColumnIndex = i
          }
        }
        this.activeColumn = column.identifier
        if (column.identifier !== 'details') {
          this.previousActiveColumn = column.identifier
        }
        resolve()
      })
    },
    toggleActiveColumn (column) {
      if(column.identifier === this.activeColumn) {
        // Active column background clicked, activate previous
        this.activeColumnIndex = Math.max(0,this.activeColumnIndex - 1)
        this.activeColumn = this.columns[this.activeColumnIndex].identifier
      } else {
        // Inactive column clicked, activate it
        this.setActiveColumn(column)
      }
    },
    loginColumns () {
      return this.makeDynamicComponent('Login', 'Login')
    },
    clientIdColumns () {
      return this.makeDynamicComponent('Client ID', 'ClientId')
    },
    makeDynamicComponent (title, type) {
      return [
        {
          identifier: 'full',
          width: 12,
          component: {
            id: 0,
            name: title,
            type: type,
            data: ''
          },
          components: [
            {
              id: 0,
              name: title,
              type: type,
              data: ''
            }
          ]
        }
      ]
    },
    async setClientId () {
      try {
        await this.$store.dispatch('clientid')
      } catch (e) {
        console.log('Unable to set client ID')
      }
    },
    print (data) {
      if (this.hasPaymentTerminal) {
        if (this.receiptprinter) { // Don't print if we have a separate ticket printer set
          return false
        }
        if (data.format !== 'png') {
          return false
        }
        if (this.literallyJustPrinted) {
          return this.addToManualPrintQueue(data)
        }
        return this.printBambora(data)
      } else if (this.hasLegacyPrinters) { // This should probably never happen
        return this.printLegacy(data)
      }
      return false
    },
    addToManualPrintQueue (data) {
      this.manualPrintQueue.push(data)
    },
    printFromManualPrintQueue () {
      if (!this.manualPrintQueue.length) {
        return
      }
      let data = this.manualPrintQueue.shift()
      this.printBambora(data)
    },
    printBambora (data) {
      this.lastPrintJobTs = Math.round((new Date()).getTime() / 1000)
      let postData = 'paymentterminal=' + this.paymentTerminalId
      this.printJobs.push({ time: new Date(), data: data })
      if (this.printJobs.length > this.printJobHistoryLength) { // Limit to a maximum number of items
        this.printJobs.shift()
      }
      for (var i = 0; i < data.data.length; i++) {
        postData += '&data[]=' + encodeURIComponent(data.data[i])
      }
      axios.post(`${this.baseDomain}${this.shopId}/bamborahandler/custom.json?action=print&apikey=${this.apiKey}`, postData)
      .then(response => {
        if (!parseInt(response.data.result)) { // result = 0 = success
          console.log('success')
        } else {
          console.log('failed')
        }
      })
      .catch(function(e) {
        console.log(e)
      })
    },
    printLegacy (data) {
      if (!this.bridge) {
        return
      }
      switch (data.type) {
        case 'receipt':
          this.bridge.call('/printHtml', [ this.receiptprinter ], data.data, { X: 0, Y: 0}, false).then(
            function(response) {
              console.log(response)
            },
            function(error, message) {
              console.log('Error:' + message)
            }
          );
          break;
      }
    },
    modifyOrder (msg) {
      if (!msg.propagated) {
        this.$socket.emit('message', {
          type: 'modifyOrder',
          shopId: this.shopId,
          data: {
            pos: this.pos,
            clientid: this.clientid,
            tabid: this.tabid,
            order: msg.order
          }
        })
      }
    },
    displayNotes (data) {
      // data.type will be either 'order' or 'bill'
      const transaction = data.transaction
      if (transaction && (transaction.notes || transaction.more)) {
        this.showDialog({
          title: this._('Notes'),
          width: 800,
          buttons: [
            {
              title: this._('Close'),
              icon: 'close',
              handler: () => {}
            },
          ],
          fields: [
            {
              title: this._('Additional info'),
              type: 'textarea',
              name: 'more',
              defaultValue: transaction.more
            },
            {
              title: this._('Notes'),
              type: 'textarea',
              name: 'notes',
              defaultValue: transaction.notes
            }
          ]
        })
      }
    },
    updateOverflowNavi: debounce(function () {
      if (this.$refs && this.$refs['side-menu']) {
        const menuItems = this.$refs['side-menu'].getElementsByTagName('li')
        const itemCount = menuItems.length
        const itemHeight = 48
        const availableHeight = window.innerHeight - 84 - itemHeight - (this.hasCampaigns ? itemHeight : 0) // Reserve space for the menu trigger and the campaigns link
        const fitCount = Math.floor(availableHeight / itemHeight)
        // If only one item goes offscreen then it will actually fit as there is no menubutton
        if(fitCount < itemCount - 1) {
          this.visibleItems = fitCount
        } else {
          this.visibleItems = itemCount
        }
      }
    }, 200),
    async checkAndJoinChannel () {
      if (this.joinChannel) {
        const data = {
          action: 'request',
          shopId: this.joinChannel,
          message: ''
        }
        let response
        try {
          response = await axios.post(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        } catch(e) {
          this.showError(e)
          return
        } finally {
          this.$store.dispatch('joinchannel', null)
        }
        this.showNotification(this._('Request to join sales channel has been sent') + '.')
      }
    },
    async campaignDismissed (item) {
      if (!this.user || !this.userData || !item || item.preview || !item.campaign_id) {
        return
      }
      try {
        await axios.post(this.baseDomain + this.shopId + '/campaigns/' + item.campaign_id + '/dismiss.json?apikey=' + this.apiKey, {
          product_id: item.product_id || 0
        })
        this.campaignItems = this.campaignItems.map(candidate => candidate.key === item.key ? Object.assign({}, candidate, { dismissed: true }) : candidate)
      } catch(e) {
        return
      }
    },
    showLatePaymentModal () {
      this.showModal('latepayment', LatePayment, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          deactivateTs: this.deactivateTs,
          notifyTs: this.notifyTs
        }
      })
    },
    initColumnResizeObserver () {
      if (typeof ResizeObserver !== 'undefined') {
        this.columnResizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            const targetId = entry.target.id
            const cr = entry.contentRect
            const elW = cr.width
            let columnWidthClasses = ''
            if(elW < 480) {
              columnWidthClasses = 'width-xxs width-xs'
            }
            if(elW > 479 && elW < 768) {
              columnWidthClasses = 'width-xs'
            }
            if(elW > 767 && elW < 992) {
              columnWidthClasses = 'width-sm'
            }
            if(elW > 991 && elW < 1200) {
              columnWidthClasses = 'width-md'
            }
            if(elW > 1199) {
              columnWidthClasses = 'width-lg'
            }
            const roundedWidth = Math.ceil(elW / 50) * 50
            columnWidthClasses += ` width-${roundedWidth}px`
            this.columnWidthClasses[targetId] = columnWidthClasses
            this.listFilterVisible[targetId] = elW > 768
          }
        })
      }
    },
    observeColumn (el) {
      if (this.columnResizeObserver && el) {
        this.columnResizeObserver.observe(el)
      }
    },
    unobserveColumn (el) {
      if (this.columnResizeObserver && el) {
        this.columnResizeObserver.unobserve(el)
      }
    }
  },
  watch: {
    // The page's colour for the system's bars: the top menu's while it shows, else none (the page's
    // background). Browsers tint their bars with it, and the Johku Hub app on iPhone colours the
    // strip under the status bar and its text by it.
    canShowMenu: {
      immediate: true,
      handler (shown) {
        if (typeof document === 'undefined') {
          return
        }
        let meta = document.querySelector('meta[name="theme-color"]')
        if (!shown) {
          meta?.remove()
          return
        }
        if (!meta) {
          meta = document.createElement('meta')
          meta.name = 'theme-color'
          document.head.appendChild(meta)
        }
        meta.content = '#1f323e'
      }
    },
    hubEnabled: {
      immediate: true,
      handler (enabled) {
        // Hub's messages live in the browser. On the server this ran after the import, with no
        // Nuxt instance left (NUXT_E1001), and its texts and state are shared by every request.
        if (import.meta.server) {
          return
        }
        if (enabled) {
          // Hub's texts (the incidents over every view) in the POS's language
          loadHub().then((hub) => {
            hub.setLocale(this.$store.state.locale)
            hub.startHubUnread(this.shopId)
          }).catch(hubFailed)
        } else {
          hubCode?.then((hub) => hub.stopHubUnread()).catch(hubFailed)
        }
      }
    },
    scheduler2Enabled: {
      immediate: true,
      handler () {
        this.syncSchedulerStyle()
      }
    },
    manualPrintQueue: {
      handler (val, oldVal) {
        if (this.manualPrintQueue.length) {
          this.$modal.show('printQueueModal')
        } else {
          this.$modal.hide('printQueueModal')
        }
      }
    },
    components: {
      deep: true, 
      handler (newValue) {
        this.myLayouts = [...newValue.filter(l => !l.hidden && !l.isSettings), { id: 'add' }]
        this.updateOverflowNavi()
      }
    },
    columns: {
      deep: true,
      async handler (newValue) {
        await nextTick()
        this.EventBus.$emit('columnRedrawTriggered')
      }
    },
    user: {
      deep: true,
      handler (newValue) {
        console.log('user changed', newValue)
        // Messages belong to the signed-in user
        if (this.hubEnabled) {
          loadHub().then((hub) => hub.recheckHub(this.shopId)).catch(hubFailed)
        }
        if (newValue && JSON.stringify(this.user) != JSON.stringify(newValue)) {
          this.reloadClient()
        }
      }
    },
    userData: {
      deep: true,
      handler (newValue) {
        if (newValue && JSON.stringify(this.userData) != JSON.stringify(newValue)) {
          this.reloadClient()
        }
      }
    },
    uiReady (ready) {
      if (ready) {
        this.maybeRestoreFromHash()
        this.loadCampaigns()
      }
    },
    hasCampaigns () {
      this.updateOverflowNavi()
    },
    version () {
      if (this.restoringFromHash || !this.uiReady) {
        return
      }
      this.replaceHash()
    }
  },
  components: {
    Login: defineAsyncComponent(() => import('~/components/Login')),
    Menu: defineAsyncComponent(() => import('~/components/Menu')),
    ProductList: defineAsyncComponent(() => import('~/components/ProductList')),
    Receipt: defineAsyncComponent(() => import('~/components/Receipt')),
    EmptyColumn: defineAsyncComponent(() => import('~/components/EmptyColumn')),
    ButtonMap: defineAsyncComponent(() => import('~/components/ButtonMap')),
    CategoryList: defineAsyncComponent(() => import('~/components/CategoryList')),
    MovieList: defineAsyncComponent(() => import('~/components/MovieList')),
    TicketActivityList: defineAsyncComponent(() => import('~/components/TicketActivityList')),
    TransactionList: defineAsyncComponent(() => import('~/components/TransactionList')),
    OpenList: defineAsyncComponent(() => import('~/components/OpenList')),
    OpenTicketList: defineAsyncComponent(() => import('~/components/OpenTicketList')),
    ClientReceipt: defineAsyncComponent(() => import('~/components/ClientReceipt')),
    ReportList: defineAsyncComponent(() => import('~/components/ReportList')),
    IFrame: defineAsyncComponent(() => import('~/components/IFrame')),
    StorefrontIFrame: defineAsyncComponent(() => import('~/components/StorefrontIFrame')),
    ClientId: defineAsyncComponent(() => import('~/components/ClientId')),
    Manage: defineAsyncComponent(() => import('~/components/Manage')),
    Reports: defineAsyncComponent(() => import('~/components/Reports')),
    ContentManagement: defineAsyncComponent(() => import('~/components/ContentManagement')),
    Settings: defineAsyncComponent(() => import('~/components/Settings')),
    GasPump: defineAsyncComponent(() => import('~/components/GasPump')),
    CreateReport: defineAsyncComponent(() => import('~/components/CreateReport')),
    ScheduledReportList: defineAsyncComponent(() => import('~/components/ScheduledReportList')),
    ArchivedReportList: defineAsyncComponent(() => import('~/components/ArchivedReportList')),
    MaccsboxResults: defineAsyncComponent(() => import('~/components/MaccsboxResults')),
    Showtimes: defineAsyncComponent(() => import('~/components/Showtimes')),
    ProductReservationSchedule: defineAsyncComponent(() => import('~/components/ProductReservationSchedule')),
    ResourceReservationSchedule: defineAsyncComponent(() => import('~/components/ResourceReservationSchedule')),
    ReservationList: defineAsyncComponent(() => import('~/components/ReservationList')),
    ReservationDetails: defineAsyncComponent(() => import('~/components/ReservationDetails')),
    Workflow: defineAsyncComponent(() => import('~/components/Workflow')),
    Importer: defineAsyncComponent(() => import('~/components/Importer')),
    RouteEditor: defineAsyncComponent(() => import('~/components/RouteEditor')),
    CustomerList: defineAsyncComponent(() => import('~/components/CustomerList')),
    CustomerDetails: defineAsyncComponent(() => import('~/components/CustomerDetails')),
    BillingCustomerList: defineAsyncComponent(() => import('~/components/BillingCustomerList')),
    BillingCustomerDetails: defineAsyncComponent(() => import('~/components/BillingCustomerDetails')),
    SubscriptionList: defineAsyncComponent(() => import('~/components/SubscriptionList')),
    SubscriptionDetails: defineAsyncComponent(() => import('~/components/SubscriptionDetails')),
    CategoryProductList: defineAsyncComponent(() => import('~/components/CategoryProductList')),
    ContentList: defineAsyncComponent(() => import('~/components/ContentList')),
    ContentDetails: defineAsyncComponent(() => import('~/components/ContentDetails')),
    CategoryDetails: defineAsyncComponent(() => import('~/components/CategoryDetails')),
    ProductDetails: defineAsyncComponent(() => import('~/components/ProductDetails')),
    ResourceList: defineAsyncComponent(() => import('~/components/ResourceList')),
    ResourceDetails: defineAsyncComponent(() => import('~/components/ResourceDetails')),
    ResourcepoolDetails: defineAsyncComponent(() => import('~/components/ResourcepoolDetails')),
    NotificationSchedule: defineAsyncComponent(() => import('~/components/NotificationSchedule')),
    DiscountList: defineAsyncComponent(() => import('~/components/DiscountList')),
    DiscountDetails: defineAsyncComponent(() => import('~/components/DiscountDetails')),
    OrderList: defineAsyncComponent(() => import('~/components/OrderList')),
    OrderDetails: defineAsyncComponent(() => import('~/components/OrderDetails')),
    ConsolidatedOrderList: defineAsyncComponent(() => import('~/components/ConsolidatedOrderList')),
    ConsolidatedOrderDetails: defineAsyncComponent(() => import('~/components/ConsolidatedOrderDetails')),
    InvoiceList: defineAsyncComponent(() => import('~/components/InvoiceList')),
    InvoiceDetails: defineAsyncComponent(() => import('~/components/InvoiceDetails')),
    SettingsMenu: defineAsyncComponent(() => import('~/components/SettingsMenu')),
    CompanyProfile: defineAsyncComponent(() => import('~/components/CompanyProfile')),
    StorefrontSettings: defineAsyncComponent(() => import('~/components/StorefrontSettings')),
    CollectionSettings: defineAsyncComponent(() => import('~/components/CollectionSettings')),
    CollectionDetails: defineAsyncComponent(() => import('~/components/CollectionDetails')),
    GroupDetails: defineAsyncComponent(() => import('~/components/GroupDetails')),
    CollectionUserDetails: defineAsyncComponent(() => import('~/components/CollectionUserDetails')),
    CommunicationSettings: defineAsyncComponent(() => import('~/components/CommunicationSettings')),
    PosSettings: defineAsyncComponent(() => import('~/components/PosSettings')),
    UiFeatureCatalog: defineAsyncComponent(() => import('~/components/UiFeatureCatalog')),
    AccountingSettings: defineAsyncComponent(() => import('~/components/AccountingSettings')),
    DeliverySettings: defineAsyncComponent(() => import('~/components/DeliverySettings')),
    DeliverymethodDetails: defineAsyncComponent(() => import('~/components/DeliverymethodDetails')),
    DeliverymethodGroupDetails: defineAsyncComponent(() => import('~/components/DeliverymethodGroupDetails')),
    PosDetails: defineAsyncComponent(() => import('~/components/PosDetails')),
    ComponentDetails: defineAsyncComponent(() => import('~/components/ComponentDetails')),
    LayoutDetails: defineAsyncComponent(() => import('~/components/LayoutDetails')),
    WidgetDetails: defineAsyncComponent(() => import('~/components/WidgetDetails')),
    UserinterfaceDetails: defineAsyncComponent(() => import('~/components/UserinterfaceDetails')),
    VoucherDetails: defineAsyncComponent(() => import('~/components/VoucherDetails')),
    PaymentPlanDetails: defineAsyncComponent(() => import('~/components/PaymentPlanDetails')),
    TagDetails: defineAsyncComponent(() => import('~/components/TagDetails')),
    PricingList: defineAsyncComponent(() => import('~/components/PricingList')),
    PricingDetails: defineAsyncComponent(() => import('~/components/PricingDetails')),
    Dashboard: defineAsyncComponent(() => import('~/components/Dashboard')),
    IssueList: defineAsyncComponent(() => import('~/components/IssueList')),
    IssueDetails: defineAsyncComponent(() => import('~/components/IssueDetails')),
    MaxArtifactList: defineAsyncComponent(() => import('~/components/MaxArtifactList')),
    MaxArtifactDetails: defineAsyncComponent(() => import('~/components/MaxArtifactDetails')),
    MaxSpecList: defineAsyncComponent(() => import('~/components/MaxSpecList')),
    FileManager: defineAsyncComponent(() => import('~/components/FileManager')),
    HubMessages: defineAsyncComponent(() => import('~/components/HubMessages')),
    MaxSpecDetails: defineAsyncComponent(() => import('~/components/MaxSpecDetails')),
    MaxDashboard: defineAsyncComponent(() => import('~/components/MaxDashboard')),
    MaxTool: defineAsyncComponent(() => import('~/components/MaxTool')),
    PageDetails: defineAsyncComponent(() => import('~/components/PageDetails')),
    Agenda: defineAsyncComponent(() => import('~/components/Agenda')),
    SalesChannelSettings: defineAsyncComponent(() => import('~/components/SalesChannelSettings')),
    TemplateList: defineAsyncComponent(() => import('~/components/TemplateList')),
    TemplateDetails: defineAsyncComponent(() => import('~/components/TemplateDetails')),
    YaleLockList: defineAsyncComponent(() => import('~/components/YaleLockList')),
    YaleLockDetails: defineAsyncComponent(() => import('~/components/YaleLockDetails')),
    CodeChecker: defineAsyncComponent(() => import('~/components/CodeChecker')),
    AuditLog: defineAsyncComponent(() => import('~/components/AuditLog')),
    AnonymizationSettings: defineAsyncComponent(() => import('~/components/AnonymizationSettings')),
    Admin: defineAsyncComponent(() => import('~/components/Admin')),
    AdminShopDetails: defineAsyncComponent(() => import('~/components/AdminShopDetails')),
    AdminCampaigns: defineAsyncComponent(() => import('~/components/AdminCampaigns')),
    AdminCampaignDetails: defineAsyncComponent(() => import('~/components/AdminCampaignDetails')),
    AdminUserAccess: defineAsyncComponent(() => import('~/components/AdminUserAccess')),
    AdminPartners: defineAsyncComponent(() => import('~/components/AdminPartners')),
    AdminPartnerDetails: defineAsyncComponent(() => import('~/components/AdminPartnerDetails')),
    AdminPartnerIntegrationDetails: defineAsyncComponent(() => import('~/components/AdminPartnerIntegrationDetails')),
    AdminPartnerApi: defineAsyncComponent(() => import('~/components/AdminPartnerApi')),
    PartnerIntegrationsSettings: defineAsyncComponent(() => import('~/components/PartnerIntegrationsSettings')),
    MessageDetails: defineAsyncComponent(() => import('~/components/MessageDetails')),
    SmartDeviceSettings: defineAsyncComponent(() => import('~/components/SmartDeviceSettings')),
    SmartDeviceDetails: defineAsyncComponent(() => import('~/components/SmartDeviceDetails')),
    SmartDeviceActionDetails: defineAsyncComponent(() => import('~/components/SmartDeviceActionDetails')),
    ScheduledTaskList: defineAsyncComponent(() => import('~/components/ScheduledTaskList')),
    ScheduledTaskDetails: defineAsyncComponent(() => import('~/components/ScheduledTaskDetails')),
    ChannexBookingsList: defineAsyncComponent(() => import('~/components/ChannexBookingsList')),
    MobilepayAttemptsList: defineAsyncComponent(() => import('~/components/MobilepayAttemptsList')),
    MobilepayAttemptDetails: defineAsyncComponent(() => import('~/components/MobilepayAttemptDetails')),
    StockScanner: defineAsyncComponent(() => import('~/components/StockScanner')),
    TicketReader: defineAsyncComponent(() => import('~/components/TicketReader')),
    CampaignMobilepay: defineAsyncComponent(() => import('~/components/modals/CampaignMobilepay')),
    LatePayment: defineAsyncComponent(() => import('~/components/modals/LatePayment')),
    UserinterfaceInfo: defineAsyncComponent(() => import('~/components/modals/UserinterfaceInfo')),
  },
  mounted() {
    const widgetDomain = useRuntimeConfig().public.widgetDomain

    let $this = this
    if (!this.isDev) {
      this.checkUpdates()
      this.updateInterval = setInterval(this.checkUpdates, 1 * this.updateDelay * 1000) // Check for updates every minute
    }
    this.EventBus.$on('detailsHostReady', (message) => {
      if (message && message.shopId && message.shopId !== this.shopId) {
        return
      }
      this.flushPendingRestore()
    })
    if (window) {
      this.maybeRestoreFromHash()
      window.onhashchange = () => {
        this.pathChanged(window.location.hash)
      }
    }

    this.initColumnResizeObserver()
    this.syncSchedulerStyle()

    this.menuSizeObserver = new ResizeObserver(entries => {
      this.updateOverflowNavi()
    })

    this.loadChannexFeed()
    if (this.isShopLateOnPayments && this.user && this.userData && !parseInt(this.selfService) && !this.isCustomerDisplay && !this.isShopLocked) {
      // Let's make sure we only show this once a day on the same browser so we don't annoy the customer too much
      const storageKey = this.shopId + '-last-late-payment-modal-shown'
      const lastShown = localStorage.getItem(storageKey)
      const now = new Date()
      const lastShownDate = lastShown ? new Date(parseInt(lastShown)) : new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
      if (now - lastShownDate >= 86400000) { // 86400000 ms in a day
        this.showLatePaymentModal()
        localStorage.setItem(storageKey, now.getTime().toString())
      }
    }
    this.$nextTick(() => {
      try {
        if(this.$refs['side-menu']) {
          this.menuSizeObserver.unobserve(this.$refs['side-menu'])
        }
      } catch(e) {
      }
      if(this.$refs['side-menu']) {
        this.menuSizeObserver.observe(this.$refs['side-menu'])
      }
      this.updateOverflowNavi()
      this.loadCampaigns()
    })
    window.addEventListener('focus', this.refreshCampaignsOnFocus)
    this.EventBus.$on('toggleRightNavi', (params) => {
      let target = false
      if(params && params.target) {
        target = params.target
      }
      this.toggleRightNavi(target)
    })
    this.EventBus.$on('campaignDismissed', (item) => {
      this.campaignDismissed(item)
    })
    this.EventBus.$on('orderPaid', (message) => {
      this.orderPaidGimmick(message)
    })
    this.EventBus.$on('toggleMenu', () => {
      this.toggleMenu()
    })
    this.EventBus.$on('toggleColumn', (message) => {
      this.toggleActiveColumn(message.column)
    })
    this.EventBus.$on('lock', (message) => {
      this.uiLocked = true
    })
    this.EventBus.$on('unlock', (message) => {
      this.uiLocked = false
    })
    this.EventBus.$on('showDetailsColumn', async (message) => {
      if (this.pendingRestore && message.component === this.pendingRestore.component && message.shopId === this.shopId) {
        this.pendingRestore = null
      }
      if (message.shopId !== this.shopId) {
        return
      }
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      let cols = []
      for (let i = 0; i < this.columns.length; i++) {
        let column = this.columns[i]
        if (column.identifier !== 'details') {
          cols.push(column)
        }
      }
      let component = {
        id: new Date().getTime(),
        type: message.component,
        name: message.title ? message.title : '',
        initData: message.data
      }
      let trail = message.data.trail ? message.data.trail : []
      const existingDetails = this.columns.find(column => column.identifier === 'details')
      let detailsColumn = {
        identifier: 'details',
        width: existingDetails && existingDetails.width ? existingDetails.width : (message.width || 4),
        component: component,
        components: [ ...trail, component ]
      }
      cols.push(detailsColumn)
      this.dynamicColumns = cols
      this.setActiveColumn(detailsColumn)
      if (!message.skipState) {
        await nextTick()
        this.pushHash()
      }
    })
    this.EventBus.$on('hideDetailsColumn', async (message) => {
      if (message.shopId !== this.shopId) {
        return
      }
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      let cols = []
      let trail = message.data && message.data.trail ? message.data.trail : []
      if (trail && trail.length > 1) {
        trail.pop()
        for (let i = 0; i < this.columns.length; i++) {
          let column = this.columns[i]
          if (column.identifier === 'details') {
            column.components = trail
            column.component = column.components[column.components.length - 1]
          }
          cols.push(column)
        }
      } else {
        if (trail && trail.length) {
          trail.pop()
        }
        for (let i = 0; i < this.columns.length; i++) {
          let column = this.columns[i]
          if (column.identifier !== 'details') {
            cols.push(column)
          }
        }
      }
      this.dynamicColumns = cols
      if ((!trail || !trail.length) && this.previousActiveColumn) {
        this.setActiveColumn(this.previousActiveColumn)
        this.previousActiveColumn = ''
      }
      if (!message.skipState) {
        await nextTick()
        this.pushHash()
      }
    })
    this.EventBus.$on('showReceiptComponent', async (message) => {
      if (message.shopId != this.shopId) {
        return
      }
      for (let i = 0; i < this.columns.length; i++) {
        let column = this.columns[i]
        for (let j = 0; j < column.components.length; j++) {
          let component = column.components[j]
          if (component && component.type == 'Receipt') {
            let data = JSON.parse(component.data)
            if (data.index == message.index) {
              this.setActiveComponent(column, component)
            }
          }
        }
      }
      // Some people might call this a hack. If the "showReceiptComponent" contains an array of events, send them to the realtime stream
      // The first and only use case of this is to select a customer for the open order, if any
      if (message.events && message.events.length) {
        await nextTick()
        for (let i = 0; i < message.events.length; i++) {
          let ev = message.events[i]
          for (let eventType in ev) {
            if (Object.prototype.hasOwnProperty.call(ev, eventType)) {
              this.$socket.emit('message', {
                type: eventType,
                ...ev[eventType]
              })
            }
          }
        }
      }
    })
    this.EventBus.$on('showFloatingReceipt', (message) => {
      if (this.isFloatingReceiptAvailable && !this.isStandardReceiptVisible) {
        this.floatingReceiptVisible = true
      }
    })
    this.EventBus.$on('hideFloatingReceipt', (message) => {
      if (this.isFloatingReceiptAvailable) {
        this.floatingReceiptVisible = false
      }
    })
    this.EventBus.$on('showCreateReportComponent', (message) => {
      if (message.shopId != this.shopId) {
        return
      }
      for (let i = 0; i < this.columns.length; i++) {
        let column = this.columns[i]
        for (let j = 0; j < column.components.length; j++) {
          let component = column.components[j]
          if (component && component.type == 'CreateReport') {
            this.setActiveComponent(column, component)
            break
          }
        }
      }
      if (message.events && message.events.length) {
        setTimeout(async () => {
          await nextTick()
          for (let i = 0; i < message.events.length; i++) {
            let ev = message.events[i]
            for (let eventType in ev) {
              if (Object.prototype.hasOwnProperty.call(ev, eventType)) {
                this.EventBus.$emit(eventType, ev[eventType])
              }
            }
          }
        }, 100)
      }
    })
    // Universal "show component" callback. @todo maybe replace the custom ones with this
    this.EventBus.$on('showComponent', async (message) => {
      if (message.shopId !== this.shopId || !message.component) {
        return
      }
      let found = false
      for (let i = 0; i < this.columns.length; i++) {
        let column = this.columns[i]
        if (!column || !column.components) {
          continue
        }
        for (let j = 0; j < column.components.length; j++) {
          let component = column.components[j]
          if (component && component.type == message.component) {
            if (message.initData) {
              component.initData = message.initData
            }
            if (message.title) {
              component.name = message.title
            }
            this.setActiveComponent(column, component)
            this.setActiveColumn(column)
            found = true
            break
          }
        }
      }
      // Didn't find the components in the current layout? Let's see if it's in any other layout
      if (!found && this.sharedLayout) {
        for (let l = 0; l < this.sharedLayout.length; l++) {
          let layout = this.sharedLayout[l]
          const links = layout && layout.ownComponent_layout ? layout.ownComponent_layout : []
          for (var j = 0; j < links.length; j++) {
            let cl = links[j]
            if (cl && cl.component && cl.component.type === message.component) {
              await this.setActiveLayout(layout.id)
              await nextTick()
              this.EventBus.$emit('showComponent', message)
              found = true
              return
            }
          }
        }
      }
      if (!found && message.component === 'SettingsMenu' && this.hasLayout('settings')) {
        await this.setActiveLayout('settings')
        await nextTick()
        this.EventBus.$emit('showComponent', message)
        return
      }
      // It's not in any of the layouts? I guess we'll need to open the thing in a new, custom tab
      if (!found) {
        let component = {
          id: new Date().getTime(),
          dynamic: true,
          type: message.component,
          name: message.title ? message.title : '',
          initData: message.initData
        }
        let cols = [...this.columns]
        let column = cols[0]
        if (!column) {
          return
        }
        cols[0].components = [ ...(column.components || []), component ]
        cols[0].component = component
        this.dynamicColumns = cols
        this.setActiveColumn(column)
        // this.setActiveComponent(column, component)
      }
      if (message.events && message.events.length) {
        await nextTick()
        for (let i = 0; i < message.events.length; i++) {
          let ev = message.events[i]
          for (let eventType in ev) {
            if (Object.prototype.hasOwnProperty.call(ev, eventType)) {
              this.EventBus.$emit(eventType, ev[eventType])
            }
          }
        }
      }
    })
    // Opens a Johku Max tool. A tool already open in this layout, or placed in another one, is
    // brought to the front, so the same tool never runs twice with separate state
    this.EventBus.$on('showMaxTool', async (message) => {
      if (!message || message.shopId !== this.shopId) {
        return
      }
      const specId = parseInt(message.specId, 10)
      const toolSpecId = (component) => {
        if (!component || component.type !== 'MaxTool') {
          return null
        }
        if (component.initData && component.initData.specId) {
          return parseInt(component.initData.specId, 10)
        }
        try {
          return parseInt(JSON.parse(component.data || '{}').specId, 10) || null
        } catch (e) {
          return null
        }
      }
      for (const column of this.columns) {
        const component = column && column.components ? column.components.find(c => toolSpecId(c) === specId) : null
        if (component) {
          await this.setActiveComponent(column, component)
          this.setActiveColumn(column)
          return
        }
      }
      if (!message.searched && this.sharedLayout) {
        for (const layout of this.sharedLayout) {
          const links = layout && layout.ownComponent_layout ? layout.ownComponent_layout : []
          if (links.some(link => link && toolSpecId(link.component) === specId)) {
            await this.setActiveLayout(layout.id)
            await nextTick()
            this.EventBus.$emit('showMaxTool', { ...message, searched: true })
            return
          }
        }
      }
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'MaxTool',
        title: message.title,
        width: 8,
        data: { specId }
      })
    })
    this.EventBus.$on('hideComponent', async (message) => {
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        return
      }
      let cols = [...this.columns]
      let column = cols[0]
      if (!column || !column.components) {
        return
      }
      cols[0].components = cols[0].components.filter(c => c.id !== message.id)
      cols[0].component = cols[0].components[cols[0].components.length - 1]
      this.dynamicColumns = cols
    })
    this.EventBus.$on('ticketReader.scanning', (active) => {
      this.ticketReaderScanning = !!active
    })
    this.EventBus.$on('manualScan', (message) => {
      if (!message || !message.code) {
        return
      }
      this.processScan(message.code)
    })
    this.EventBus.$on('nextManualPrintJob', () => {
      this.printFromManualPrintQueue()
    })
    this.EventBus.$on('startFilling', (data) => {
      this.$socket.emit('message', {
        type: 'startFilling', 
        pumpIndex: data.pumpIndex,
        reserve: data.reserve,
        shopId: this.shopId
      })
    })
    this.EventBus.$on('stopFilling', (data) => {
      this.$socket.emit('message', {
        type: 'stopFilling', 
        pumpIndex: data.pumpIndex,
        shopId: this.shopId
      })
    })
    this.EventBus.$on('requestGasPumpStatus', (data) => {
      this.$socket.emit('message', {
        type: 'requestGasPumpStatus', 
        shopId: this.shopId
      })
    })
    this.EventBus.$on('requestPrinters', (data) => {
      this.$socket.emit('message', {
        type: 'requestPrinters',
        data: {},
        shopId: this.shopId
      })
    })
    this.EventBus.$on('setPrinterProperties', (data) => {
      this.$socket.emit('message', {
        type: 'setPrinterProperties',
        data: data,
        shopId: this.shopId
      })
    })
    this.EventBus.$on('bamboraCmd', (msg) => {
      this.$socket.emit('message', msg)
    })
    this.EventBus.$on('reloadClient', () => { // We can also manually trigger this
      this.reloadClient()
    })
    this.EventBus.$on('gotoLayout', async (data) => {
      if (!data || !data.id) {
        return
      }
      this.dynamicColumns = null
      this.pendingRestore = null
      this.restoreGeneration += 1
      this.pushHash(data.id, true)
      await this.reloadClient()
    })
    this.EventBus.$on('modifyOrder', this.modifyOrder)
    if (this.linkedStores.length) {
      for (var j = 0; j < this.linkedStores.length; j++) {
        let linkedStore = this.linkedStores[j]
        if (linkedStore && linkedStore.shopid) {
          this.$socket.emit('channel', {
            action: 'join',
            shopId: linkedStore.shopid,
            parentShopId: this.shopId
          })
        }
      }
    }
    this.EventBus.$on('showResponseNote', (message) => {
      this.showWarning(message)
    })
    this.EventBus.$on('displayNotes', this.displayNotes)
    this.$socket.on('message', (message) => {
      // Don't replay already seen messages
      if (message.ts < this.lastSeenMessageTs) {
        return
      }
      let basketIds = $this.$store.state.basketIds
      $this.$store.dispatch('setHeartbeatTs')
      this.setLastSeenMessageTs(message.ts)
      delete message.ts // Remove this so that memoized debounce handlers don't get thwarted
      switch (message.type) {
        case 'livenessProbe':
          return
        case 'maxDataChanged':
          // A Max tool saved a change on another device or window: open tools that read those
          // record types reload. The window that saved it already told its own tools in-tab.
          if (message.shopId !== $this.shopId || !message.data || message.data.origin === maxWindowId) {
            return
          }
          this.EventBus.$emit('maxDataChanged', {
            shopId: message.shopId,
            specId: message.data.specId,
            origin: null,
            types: Array.isArray(message.data.types) ? message.data.types : []
          })
          return
        case 'basketUpdate':
          if (!message.data || !message.data.id || !message.data.id.length) {
            return
          }
          let index = message.data.id.substr(message.data.id.length - 1)
          let identifier = message.shopId + '-' + index
          if (!basketIds[identifier]) {
            return
          }
          if (basketIds[identifier] == message.data.id) {
            if (message.data.items) {
              $this.$store.dispatch('setBasketItems', { shopId: message.shopId, index: index, items: message.data.items })
            } else {
              $this.$store.dispatch('reloadBasket', identifier)
            }
            if (message.data.hasOwnProperty('deliveryId')) {
              $this.$store.dispatch('setActiveDelivery', { shopId: message.shopId, index: index, deliveryId: message.data.deliveryId })
            }
          }
          break
        case 'clientUpdate':
          if ($this.$store.state.clientid == message.data.identifier || $this.$store.state.clientIdNumber == message.data.id) {
            // Reordering layouts triggers this same event as an echo of our own change.
            // Reloading while (or immediately after) a drag is in progress races with the
            // local drag-and-drop state and can corrupt or drop layout menu items, so we
            // briefly ignore the echo here; any other pending changes will be picked up by
            // the next reload.
            if (Date.now() > $this.layoutReorderGuardUntil) {
              $this.reloadClient()
            }
          }
          this.EventBus.$emit(message.type, message)
          break
        case 'componentUpdate':
          if ($this.hasComponent(message.data.id)) {
            $this.reloadClient()
          }
          this.EventBus.$emit(message.type, message)
          break
        case 'layoutUpdate':
          if ($this.hasLayout(message.data.id)) {
            $this.reloadClient()
          }
          this.EventBus.$emit(message.type, message)
          break
        case 'settingsUpdate':
          if (!$this.activeShops[message.shopId]) {
            return
          }
          $this.reloadSettings(message.shopId)
          this.EventBus.$emit(message.type, message)
          break
        case 'print':
          if ($this.$store.state.pos == message.data.pos && $this.$store.state.clientid == message.data.client) {
            $this.print(message.data)
          }
          break
        case 'bamborastatechanged':
          if ($this.$store.state.clientid == message.data.client && $this.activeShops[message.shopId]) {
            this.EventBus.$emit(message.type, message)
          }
          break
        case 'modifyOrder':
          if ($this.$store.state.pos === message.data.pos && $this.shopId === message.shopId && ($this.$store.state.clientid !== message.data.clientid || $this.$store.state.tabid !== message.data.tabid)) {
            this.EventBus.$emit('modifyOrder', {
              order: message.data.order,
              propagated: true
            })
          }
          break
        case 'orderPaid':
          if (parseInt($this.gimmicks)) {
            $this.orderPaidGimmick(message)
          }
          break
        case 'userUpdate':
          if (message.shopId === $this.shopId && message.data && message.data.id === $this.user) {
            $this.$store.dispatch('userdata', true)
            $this.reloadSettings(message.shopId)
          }
          break
        case 'productUpdate':
        case 'availabilityUpdate':
        case 'availabilityCacheUpdate':
          if (!$this.activeShops[message.shopId]) { // This is for events that should be propagated to the current shop and its submerchants
            return
          }
          this.EventBus.$emit(message.type, message)
          break
        case 'channexmessageUpdate':
          if (message.shopId !== $this.shopId) { // This is for events that only affect the current shop
            return
          }
          this.loadChannexFeed()
          this.EventBus.$emit(message.type, message)
          break
        case 'issueUpdate':
          if (message.shopId !== $this.shopId) { // This is for events that only affect the current shop
            return
          }
          this.EventBus.$emit(message.type, message)
          if (message && message.data && message.data.type === 'report' && message.data.created) {
            this.showError(this._('An error has occurred while attempting to create a report.') + ' ' + this._('Please see the issues view in the dashboard for more information.'))
          }
          if (message && message.data && message.data.type === 'backgroundtask' && message.data.created) {
            this.showError(this._('An error has occurred while attempting to run a background task.') + ' ' + this._('Please see the issues view in the dashboard for more information.'))
          }
          break
        case 'mobilepayQrStatus':
          if (message.shopId !== $this.shopId) {
            return
          }
          if (message && message.data && message.data.merchantQrId) {
            const posId = message.data.merchantQrId.replace('pos-', '')
            if (posId == $this.$store.state.pos) {
              $this.$store.dispatch('setMobilepayToken', message.data.customerToken)
            }
          }
          break
        case 'categoryUpdate':
        case 'collectionUpdate':
        case 'usergroupUpdate':
        case 'reservationUpdate':
        case 'resourceUpdate':
        case 'resourcepoolUpdate':
        case 'gasUpdate':
        case 'gasPumpStatus':
        case 'gasPumpTransaction':
        case 'deliverymethodUpdate':
        case 'deliverymethodgroupUpdate':
        case 'orderUpdate':
        case 'billUpdate':
        case 'addPayment':
        case 'removePayment':
        case 'clearPayments':
        case 'approve':
        case 'cancelapprove':
        case 'openSeatmap':
        case 'closeSeatmap':
        case 'seatSelected':
        case 'seatDeselected':
        case 'setCustomer':
        case 'setBillingcustomer':
        case 'clearCustomer':
        case 'clearBillingcustomer':
        case 'taskUpdate':
        case 'showUpdate':
        case 'scheduledReportUpdate':
        case 'customerUpdate':
        case 'billingCustomerUpdate':
        case 'cmsrouteUpdate':
        case 'cmsproductUpdate':
        case 'cmscategoryUpdate':
        case 'cmstemplateUpdate':
        case 'cmscontentUpdate':
        case 'bamboraStatus':
        case 'posUpdate':
        case 'voucherUpdate':
        case 'deliveryUpdate':
        case 'discountUpdate':
        case 'issueUpdate':
        case 'lockUpdate':
        case 'widgetUpdate':
        case 'templateUpdate':
        case 'pricingUpdate':
        case 'routeUpdate':
        case 'messageUpdate':
        case 'scheduledTaskUpdate':
        case 'batchResourceUpdateBegin':
        case 'batchResourceUpdateEnd':
        case 'termsUpdate':
        case 'formUpdate':
        case 'paymentlinkActivate':
        case 'printers':
        case 'tagUpdate':
        case 'pospaymentUpdate':
        case 'paymentplanUpdate':
        case 'mobilepayStatus':
        case 'startMobilepayIdentification':
        case 'stopMobilepayIdentification':
          if (message.shopId !== $this.shopId) { // This is for events that only affect the current shop
            return
          }
          this.EventBus.$emit(message.type, message)
          break
      }
    })
    // Init global keyboard handler
    this.flushTimeout = false
    window.addEventListener('keypress', this.handleInput) // eslint-disable-line no-undef
    // vh-fix for mobile browsers
    // let vh = window.innerHeight * 0.01;
    // document.documentElement.style.setProperty('--vh', `${vh}px`);
    // window.addEventListener('resize', () => {
    //  let vh = window.innerHeight * 0.01;
    //  document.documentElement.style.setProperty('--vh', `${vh}px`);
    // });

    this.syncFullScreenMode()
    document.addEventListener('fullscreenchange', this.syncFullScreenMode)
    document.addEventListener('webkitfullscreenchange', this.syncFullScreenMode)
    document.addEventListener('mozfullscreenchange', this.syncFullScreenMode)
    this.checkAndJoinChannel()
    useHead({
      title: this.title,
      script: [
        {
          src: `${widgetDomain}widget.js`,
          type: 'text/javascript',
          id: 'johku-widget-js',
          async: true
        }
      ]
    })
  },
  beforeUnmount () {
    hubCode?.then((hub) => hub.stopHubUnread())
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.remove('scheduler2')
    }
    window.removeEventListener('focus', this.refreshCampaignsOnFocus)
    document.removeEventListener('fullscreenchange', this.syncFullScreenMode)
    document.removeEventListener('webkitfullscreenchange', this.syncFullScreenMode)
    document.removeEventListener('mozfullscreenchange', this.syncFullScreenMode)
    this.EventBus.$off('campaignDismissed')
    this.EventBus.$off('orderPaid')
    this.EventBus.$off('toggleMenu')
    this.EventBus.$off('lock')
    this.EventBus.$off('unlock')
    this.EventBus.$off('showReceiptComponent')
    this.EventBus.$off('showDetailsColumn')
    this.EventBus.$off('hideDetailsColumn')
    this.EventBus.$off('showFloatingReceipt')
    this.EventBus.$off('hideFloatingReceipt')
    this.EventBus.$off('showCreateReportComponent')
    this.EventBus.$off('showComponent')
    this.EventBus.$off('showMaxTool')
    this.EventBus.$off('hideComponent')
    this.EventBus.$off('ticketReader.scanning')
    this.EventBus.$off('manualScan')
    this.EventBus.$off('nextManualPrintJob')
    this.EventBus.$off('stopFilling')
    this.EventBus.$off('requestGasPumpStatus')
    this.EventBus.$off('bamboraCmd')
    this.EventBus.$off('reloadClient')
    this.EventBus.$off('gotoLayout')
    this.EventBus.$off('detailsHostReady')
    this.EventBus.$off('showResponseNote')
    this.EventBus.$off('modifyOrder', this.modifyOrder)
    if (this.$socket) {
      this.$socket.off('message')
    }
    try {
      this.menuSizeObserver.unobserve(this.$refs['side-menu'])
      this.menuSizeObserver.disconnect()
    } catch(e) {}
    try {
      if (this.columnResizeObserver) {
        this.columnResizeObserver.disconnect()
        this.columnResizeObserver = null
      }
    } catch(e) {}
    clearInterval(this.updateInterval)
  },
})
</script>
<style>
#gimmick {
  display: block;
  pointer-events: none;
  position: absolute;
  z-index: 2000;
  top: 0;
  left: 0;
}
.no-menu .off-screen {
  display: none !important;
}
.menu-layout .layout-strip.with-campaigns-link {
  flex-direction: column;
}
.menu-layout .layout-strip .campaigns-link {
  flex: 0 0 auto;
  background-color: #455964;
}
.has-campaigns-link .menu-overflow-wrap {
  bottom: 42px;
}
@media (min-width: 768px) {
  .has-campaigns-link .menu-overflow-wrap {
    bottom: 48px;
  }
}
.show-menu {

}
.shop-locker {
  display: block;
  position: absolute;
  z-index: 30000;
  top: 0;
  left: 0; 
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}
.menu-hamburger {
  position: relative;
}
.hub-incidents-overlay {
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: min(560px, calc(100vw - 20px));
  z-index: 1040;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.hub-incidents-overlay:empty {
  display: none;
}

.hub-unread-dot {
  position: absolute;
  top: 8px;
  right: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e5533d;
}
.hub-unread-count {
  background: #e5533d;
}
.shop-locker > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-shadow: 2px 2px 1px rgba(255, 255, 255, 0.7);
}
</style>